var _path, _g, _g2, _path2, _g3, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _g5, _path9, _path0, _g6, _path1, _path10, _g7, _path11, _path12, _g8, _path13, _path14, _g9, _path15, _path16, _g0, _path17, _path18, _g1, _path19, _path20, _g10, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g11, _path38, _path39, _path40, _path41, _g12, _g13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 273,
    viewBox: "0 0 486 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_346_1217)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 486,
    height: 273
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476 5C478.76 5 481 7.24 481 10V263C481 265.76 478.76 268 476 268H10C7.24 268 5 265.76 5 263V10C5 7.24 7.24 5 10 5H476ZM476 0H10C4.48 0 0 4.48 0 10V263C0 268.52 4.48 273 10 273H476C481.52 273 486 268.52 486 263V10C486 4.48 481.52 0 476 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4 0H0V273H32.4V0Z",
    fill: "#200508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 0H32.4V273H64.8V0Z",
    fill: "#1F0508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2 0H64.8V273H97.2V0Z",
    fill: "#1E0507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 0H97.2V273H129.6V0Z",
    fill: "#1D0507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 0H129.6V273H162V0Z",
    fill: "#1C0407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4 0H162V273H194.4V0Z",
    fill: "#1B0407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 0H194.4V273H226.8V0Z",
    fill: "#1A0406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 0H226.8V273H259.2V0Z",
    fill: "#190406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.6 0H259.2V273H291.6V0Z",
    fill: "#170406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 0H291.6V273H324V0Z",
    fill: "#160405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4 0H324V273H356.4V0Z",
    fill: "#150405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8 0H356.4V273H388.8V0Z",
    fill: "#140305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 0H388.8V273H421.2V0Z",
    fill: "#130305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.6 0H421.2V273H453.6V0Z",
    fill: "#120304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 0H453.6V273H486V0Z",
    fill: "#110304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4 5H5V268H32.4V5Z",
    fill: "#200508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 5H32.4V268H64.8V5Z",
    fill: "#1F0508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2 5H64.8V268H97.2V5Z",
    fill: "#1E0507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 5H97.2V268H129.6V5Z",
    fill: "#1D0507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 5H129.6V268H162V5Z",
    fill: "#1C0407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4 5H162V268H194.4V5Z",
    fill: "#1B0407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 5H194.4V268H226.8V5Z",
    fill: "#1A0406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 5H226.8V268H259.2V5Z",
    fill: "#190406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.6 5H259.2V268H291.6V5Z",
    fill: "#170406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 5H291.6V268H324V5Z",
    fill: "#160405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4 5H324V268H356.4V5Z",
    fill: "#150405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8 5H356.4V268H388.8V5Z",
    fill: "#140305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 5H388.8V268H421.2V5Z",
    fill: "#130305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.6 5H421.2V268H453.6V5Z",
    fill: "#120304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 5H453.6V268H481V5Z",
    fill: "#110304"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.01 5H475.98C478.75 5 480.99 7.25 480.99 10.01V262.99C480.99 265.76 478.74 268 475.98 268H10.01C7.24 268 5 265.75 5 262.99V10.01C5 7.24 7.25 5 10.01 5Z",
    fill: "url(#paint0_linear_346_1217)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 35,
    width: 476,
    height: 233
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.1 35.04H9.89999C7.29321 35.04 5.17999 37.1532 5.17999 39.76V263.28C5.17999 265.887 7.29321 268 9.89999 268H476.1C478.707 268 480.82 265.887 480.82 263.28V39.76C480.82 37.1532 478.707 35.04 476.1 35.04Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 40.25C466.66 40.75 467.06 41.15 467.56 41.15C468.06 41.15 468.46 40.75 468.46 40.25C468.46 39.75 468.06 39.35 467.56 39.35C467.06 39.35 466.66 39.75 466.66 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 62.69C466.66 63.19 467.06 63.59 467.56 63.59C468.06 63.59 468.46 63.19 468.46 62.69C468.46 62.19 468.06 61.79 467.56 61.79C467.06 61.79 466.66 62.19 466.66 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 85.12C466.66 85.62 467.06 86.02 467.56 86.02C468.06 86.02 468.46 85.62 468.46 85.12C468.46 84.62 468.06 84.22 467.56 84.22C467.06 84.22 466.66 84.62 466.66 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M467.56 108.46C467.07 108.46 466.66 108.06 466.66 107.56C466.66 107.06 467.06 106.66 467.56 106.66C468.06 106.66 468.46 107.06 468.46 107.56C468.46 108.06 468.06 108.46 467.56 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 130C466.66 130.5 467.06 130.9 467.56 130.9C468.06 130.9 468.46 130.5 468.46 130C468.46 129.5 468.06 129.1 467.56 129.1C467.06 129.1 466.66 129.5 466.66 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 152.44C466.66 152.94 467.06 153.34 467.56 153.34C468.06 153.34 468.46 152.94 468.46 152.44C468.46 151.94 468.06 151.54 467.56 151.54C467.06 151.54 466.66 151.94 466.66 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M467.56 175.77C467.07 175.77 466.66 175.37 466.66 174.87C466.66 174.37 467.06 173.97 467.56 173.97C468.06 173.97 468.46 174.37 468.46 174.87C468.46 175.37 468.06 175.77 467.56 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 197.31C466.66 197.81 467.06 198.21 467.56 198.21C468.06 198.21 468.46 197.81 468.46 197.31C468.46 196.81 468.06 196.41 467.56 196.41C467.06 196.41 466.66 196.81 466.66 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 219.75C466.66 220.25 467.06 220.65 467.56 220.65C468.06 220.65 468.46 220.25 468.46 219.75C468.46 219.25 468.06 218.85 467.56 218.85C467.06 218.85 466.66 219.25 466.66 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M467.56 243.09C467.07 243.09 466.66 242.69 466.66 242.19C466.66 241.69 467.06 241.29 467.56 241.29C468.06 241.29 468.46 241.69 468.46 242.19C468.46 242.69 468.06 243.09 467.56 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.66 264.63C466.66 265.13 467.06 265.53 467.56 265.53C468.06 265.53 468.46 265.13 468.46 264.63C468.46 264.13 468.06 263.73 467.56 263.73C467.06 263.73 466.66 264.13 466.66 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 40.25C449.39 40.75 449.79 41.15 450.29 41.15C450.79 41.15 451.19 40.75 451.19 40.25C451.19 39.75 450.79 39.35 450.29 39.35C449.79 39.35 449.39 39.75 449.39 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 62.69C449.39 63.19 449.79 63.59 450.29 63.59C450.79 63.59 451.19 63.19 451.19 62.69C451.19 62.19 450.79 61.79 450.29 61.79C449.79 61.79 449.39 62.19 449.39 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 85.12C449.39 85.62 449.79 86.02 450.29 86.02C450.79 86.02 451.19 85.62 451.19 85.12C451.19 84.62 450.79 84.22 450.29 84.22C449.79 84.22 449.39 84.62 449.39 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M450.29 108.46C449.8 108.46 449.39 108.06 449.39 107.56C449.39 107.06 449.79 106.66 450.29 106.66C450.79 106.66 451.19 107.06 451.19 107.56C451.19 108.06 450.79 108.46 450.29 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 130C449.39 130.5 449.79 130.9 450.29 130.9C450.79 130.9 451.19 130.5 451.19 130C451.19 129.5 450.79 129.1 450.29 129.1C449.79 129.1 449.39 129.5 449.39 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 152.44C449.39 152.94 449.79 153.34 450.29 153.34C450.79 153.34 451.19 152.94 451.19 152.44C451.19 151.94 450.79 151.54 450.29 151.54C449.79 151.54 449.39 151.94 449.39 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M450.29 175.77C449.8 175.77 449.39 175.37 449.39 174.87C449.39 174.37 449.79 173.97 450.29 173.97C450.79 173.97 451.19 174.37 451.19 174.87C451.19 175.37 450.79 175.77 450.29 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 197.31C449.39 197.81 449.79 198.21 450.29 198.21C450.79 198.21 451.19 197.81 451.19 197.31C451.19 196.81 450.79 196.41 450.29 196.41C449.79 196.41 449.39 196.81 449.39 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 219.75C449.39 220.25 449.79 220.65 450.29 220.65C450.79 220.65 451.19 220.25 451.19 219.75C451.19 219.25 450.79 218.85 450.29 218.85C449.79 218.85 449.39 219.25 449.39 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M450.29 243.09C449.8 243.09 449.39 242.69 449.39 242.19C449.39 241.69 449.79 241.29 450.29 241.29C450.79 241.29 451.19 241.69 451.19 242.19C451.19 242.69 450.79 243.09 450.29 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.39 264.63C449.39 265.13 449.79 265.53 450.29 265.53C450.79 265.53 451.19 265.13 451.19 264.63C451.19 264.13 450.79 263.73 450.29 263.73C449.79 263.73 449.39 264.13 449.39 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 41.15C432.52 41.15 432.11 40.75 432.11 40.25C432.11 39.75 432.51 39.35 433.01 39.35C433.51 39.35 433.91 39.75 433.91 40.25C433.91 40.75 433.51 41.15 433.01 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 63.58C432.52 63.58 432.11 63.18 432.11 62.68C432.11 62.18 432.51 61.78 433.01 61.78C433.51 61.78 433.91 62.18 433.91 62.68C433.91 63.18 433.51 63.58 433.01 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 86.02C432.52 86.02 432.11 85.62 432.11 85.12C432.11 84.62 432.51 84.22 433.01 84.22C433.51 84.22 433.91 84.62 433.91 85.12C433.91 85.62 433.51 86.02 433.01 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 108.46C432.52 108.46 432.11 108.06 432.11 107.56C432.11 107.06 432.51 106.66 433.01 106.66C433.51 106.66 433.91 107.06 433.91 107.56C433.91 108.06 433.51 108.46 433.01 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 130.9C432.52 130.9 432.11 130.5 432.11 130C432.11 129.5 432.51 129.1 433.01 129.1C433.51 129.1 433.91 129.5 433.91 130C433.91 130.5 433.51 130.9 433.01 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 153.34C432.52 153.34 432.11 152.94 432.11 152.44C432.11 151.94 432.51 151.54 433.01 151.54C433.51 151.54 433.91 151.94 433.91 152.44C433.91 152.94 433.51 153.34 433.01 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 175.77C432.52 175.77 432.11 175.37 432.11 174.87C432.11 174.37 432.51 173.97 433.01 173.97C433.51 173.97 433.91 174.37 433.91 174.87C433.91 175.37 433.51 175.77 433.01 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 198.21C432.52 198.21 432.11 197.81 432.11 197.31C432.11 196.81 432.51 196.41 433.01 196.41C433.51 196.41 433.91 196.81 433.91 197.31C433.91 197.81 433.51 198.21 433.01 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 220.65C432.52 220.65 432.11 220.25 432.11 219.75C432.11 219.25 432.51 218.85 433.01 218.85C433.51 218.85 433.91 219.25 433.91 219.75C433.91 220.25 433.51 220.65 433.01 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 243.09C432.52 243.09 432.11 242.69 432.11 242.19C432.11 241.69 432.51 241.29 433.01 241.29C433.51 241.29 433.91 241.69 433.91 242.19C433.91 242.69 433.51 243.09 433.01 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.01 265.53C432.52 265.53 432.11 265.13 432.11 264.63C432.11 264.13 432.51 263.73 433.01 263.73C433.51 263.73 433.91 264.13 433.91 264.63C433.91 265.13 433.51 265.53 433.01 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 40.25C414.84 40.75 415.24 41.15 415.73 41.15C416.22 41.15 416.63 40.75 416.63 40.25C416.63 39.75 416.23 39.35 415.73 39.35C415.23 39.35 414.84 39.75 414.84 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 62.69C414.84 63.19 415.24 63.59 415.73 63.59C416.22 63.59 416.63 63.19 416.63 62.69C416.63 62.19 416.23 61.79 415.73 61.79C415.23 61.79 414.84 62.19 414.84 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 85.12C414.84 85.62 415.24 86.02 415.73 86.02C416.22 86.02 416.63 85.62 416.63 85.12C416.63 84.62 416.23 84.22 415.73 84.22C415.23 84.22 414.84 84.62 414.84 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M415.74 108.46C415.25 108.46 414.85 108.06 414.85 107.56C414.85 107.06 415.25 106.66 415.74 106.66C416.23 106.66 416.64 107.06 416.64 107.56C416.64 108.06 416.24 108.46 415.74 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 130C414.84 130.5 415.24 130.9 415.73 130.9C416.22 130.9 416.63 130.5 416.63 130C416.63 129.5 416.23 129.1 415.73 129.1C415.23 129.1 414.84 129.5 414.84 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 152.44C414.84 152.94 415.24 153.34 415.73 153.34C416.22 153.34 416.63 152.94 416.63 152.44C416.63 151.94 416.23 151.54 415.73 151.54C415.23 151.54 414.84 151.94 414.84 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M415.74 175.77C415.25 175.77 414.85 175.37 414.85 174.87C414.85 174.37 415.25 173.97 415.74 173.97C416.23 173.97 416.64 174.37 416.64 174.87C416.64 175.37 416.24 175.77 415.74 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 197.31C414.84 197.81 415.24 198.21 415.73 198.21C416.22 198.21 416.63 197.81 416.63 197.31C416.63 196.81 416.23 196.41 415.73 196.41C415.23 196.41 414.84 196.81 414.84 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 219.75C414.84 220.25 415.24 220.65 415.73 220.65C416.22 220.65 416.63 220.25 416.63 219.75C416.63 219.25 416.23 218.85 415.73 218.85C415.23 218.85 414.84 219.25 414.84 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M415.74 243.09C415.25 243.09 414.85 242.69 414.85 242.19C414.85 241.69 415.25 241.29 415.74 241.29C416.23 241.29 416.64 241.69 416.64 242.19C416.64 242.69 416.24 243.09 415.74 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M414.84 264.63C414.84 265.12 415.24 265.53 415.73 265.53C416.22 265.53 416.63 265.13 416.63 264.63C416.63 264.13 416.23 263.73 415.73 263.73C415.23 263.73 414.84 264.13 414.84 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 41.15C397.97 41.15 397.56 40.75 397.56 40.25C397.56 39.75 397.96 39.35 398.46 39.35C398.96 39.35 399.36 39.75 399.36 40.25C399.36 40.75 398.96 41.15 398.46 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 63.58C397.97 63.58 397.56 63.18 397.56 62.68C397.56 62.18 397.96 61.78 398.46 61.78C398.96 61.78 399.36 62.18 399.36 62.68C399.36 63.18 398.96 63.58 398.46 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 86.02C397.97 86.02 397.56 85.62 397.56 85.12C397.56 84.62 397.96 84.22 398.46 84.22C398.96 84.22 399.36 84.62 399.36 85.12C399.36 85.62 398.96 86.02 398.46 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 108.46C397.97 108.46 397.56 108.06 397.56 107.56C397.56 107.06 397.96 106.66 398.46 106.66C398.96 106.66 399.36 107.06 399.36 107.56C399.36 108.06 398.96 108.46 398.46 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 130.9C397.97 130.9 397.56 130.5 397.56 130C397.56 129.5 397.96 129.1 398.46 129.1C398.96 129.1 399.36 129.5 399.36 130C399.36 130.5 398.96 130.9 398.46 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 153.34C397.97 153.34 397.56 152.94 397.56 152.44C397.56 151.94 397.96 151.54 398.46 151.54C398.96 151.54 399.36 151.94 399.36 152.44C399.36 152.94 398.96 153.34 398.46 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 175.77C397.97 175.77 397.56 175.37 397.56 174.87C397.56 174.37 397.96 173.97 398.46 173.97C398.96 173.97 399.36 174.37 399.36 174.87C399.36 175.37 398.96 175.77 398.46 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 198.21C397.97 198.21 397.56 197.81 397.56 197.31C397.56 196.81 397.96 196.41 398.46 196.41C398.96 196.41 399.36 196.81 399.36 197.31C399.36 197.81 398.96 198.21 398.46 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 220.65C397.97 220.65 397.56 220.25 397.56 219.75C397.56 219.25 397.96 218.85 398.46 218.85C398.96 218.85 399.36 219.25 399.36 219.75C399.36 220.25 398.96 220.65 398.46 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 243.09C397.97 243.09 397.56 242.69 397.56 242.19C397.56 241.69 397.96 241.29 398.46 241.29C398.96 241.29 399.36 241.69 399.36 242.19C399.36 242.69 398.96 243.09 398.46 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.46 265.53C397.97 265.53 397.56 265.13 397.56 264.63C397.56 264.13 397.96 263.73 398.46 263.73C398.96 263.73 399.36 264.13 399.36 264.63C399.36 265.13 398.96 265.53 398.46 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 41.15C380.7 41.15 380.3 40.75 380.3 40.25C380.3 39.75 380.7 39.35 381.19 39.35C381.68 39.35 382.09 39.75 382.09 40.25C382.09 40.75 381.69 41.15 381.19 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 63.58C380.7 63.58 380.3 63.18 380.3 62.68C380.3 62.18 380.7 61.78 381.19 61.78C381.68 61.78 382.09 62.18 382.09 62.68C382.09 63.18 381.69 63.58 381.19 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 86.02C380.7 86.02 380.3 85.62 380.3 85.12C380.3 84.62 380.7 84.22 381.19 84.22C381.68 84.22 382.09 84.62 382.09 85.12C382.09 85.62 381.69 86.02 381.19 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 108.46C380.7 108.46 380.3 108.06 380.3 107.56C380.3 107.06 380.7 106.66 381.19 106.66C381.68 106.66 382.09 107.06 382.09 107.56C382.09 108.06 381.69 108.46 381.19 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 130.9C380.7 130.9 380.3 130.5 380.3 130C380.3 129.5 380.7 129.1 381.19 129.1C381.68 129.1 382.09 129.5 382.09 130C382.09 130.5 381.69 130.9 381.19 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 153.34C380.7 153.34 380.3 152.94 380.3 152.44C380.3 151.94 380.7 151.54 381.19 151.54C381.68 151.54 382.09 151.94 382.09 152.44C382.09 152.94 381.69 153.34 381.19 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 175.77C380.7 175.77 380.3 175.37 380.3 174.87C380.3 174.37 380.7 173.97 381.19 173.97C381.68 173.97 382.09 174.37 382.09 174.87C382.09 175.37 381.69 175.77 381.19 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 198.21C380.7 198.21 380.3 197.81 380.3 197.31C380.3 196.81 380.7 196.41 381.19 196.41C381.68 196.41 382.09 196.81 382.09 197.31C382.09 197.81 381.69 198.21 381.19 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 220.65C380.7 220.65 380.3 220.25 380.3 219.75C380.3 219.25 380.7 218.85 381.19 218.85C381.68 218.85 382.09 219.25 382.09 219.75C382.09 220.25 381.69 220.65 381.19 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 243.09C380.7 243.09 380.3 242.69 380.3 242.19C380.3 241.69 380.7 241.29 381.19 241.29C381.68 241.29 382.09 241.69 382.09 242.19C382.09 242.69 381.69 243.09 381.19 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.19 265.53C380.7 265.53 380.3 265.13 380.3 264.63C380.3 264.13 380.7 263.73 381.19 263.73C381.68 263.73 382.09 264.13 382.09 264.63C382.09 265.13 381.69 265.53 381.19 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 40.25C363.02 40.75 363.42 41.15 363.92 41.15C364.42 41.15 364.81 40.75 364.81 40.25C364.81 39.75 364.41 39.35 363.92 39.35C363.43 39.35 363.02 39.75 363.02 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 62.69C363.02 63.19 363.42 63.59 363.92 63.59C364.42 63.59 364.81 63.19 364.81 62.69C364.81 62.19 364.41 61.79 363.92 61.79C363.43 61.79 363.02 62.19 363.02 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 85.12C363.02 85.62 363.42 86.02 363.92 86.02C364.42 86.02 364.81 85.62 364.81 85.12C364.81 84.62 364.41 84.22 363.92 84.22C363.43 84.22 363.02 84.62 363.02 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.92 108.46C363.43 108.46 363.02 108.06 363.02 107.56C363.02 107.06 363.42 106.66 363.92 106.66C364.42 106.66 364.81 107.06 364.81 107.56C364.81 108.06 364.41 108.46 363.92 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 130C363.02 130.5 363.42 130.9 363.92 130.9C364.42 130.9 364.81 130.5 364.81 130C364.81 129.5 364.41 129.1 363.92 129.1C363.43 129.1 363.02 129.5 363.02 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 152.44C363.02 152.94 363.42 153.34 363.91 153.34C364.4 153.34 364.81 152.94 364.81 152.44C364.81 151.94 364.41 151.54 363.91 151.54C363.41 151.54 363.02 151.94 363.02 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.92 175.77C363.43 175.77 363.03 175.37 363.03 174.87C363.03 174.37 363.43 173.97 363.92 173.97C364.41 173.97 364.82 174.37 364.82 174.87C364.82 175.37 364.42 175.77 363.92 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 197.31C363.02 197.81 363.42 198.21 363.91 198.21C364.4 198.21 364.81 197.81 364.81 197.31C364.81 196.81 364.41 196.41 363.91 196.41C363.41 196.41 363.02 196.81 363.02 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 219.75C363.02 220.25 363.42 220.65 363.91 220.65C364.4 220.65 364.81 220.25 364.81 219.75C364.81 219.25 364.41 218.85 363.91 218.85C363.41 218.85 363.02 219.25 363.02 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.92 243.09C363.43 243.09 363.03 242.69 363.03 242.19C363.03 241.69 363.43 241.29 363.92 241.29C364.41 241.29 364.82 241.69 364.82 242.19C364.82 242.69 364.42 243.09 363.92 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.02 264.63C363.02 265.12 363.42 265.53 363.91 265.53C364.4 265.53 364.81 265.13 364.81 264.63C364.81 264.13 364.41 263.73 363.91 263.73C363.41 263.73 363.02 264.13 363.02 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 41.15C346.15 41.15 345.74 40.75 345.74 40.25C345.74 39.75 346.14 39.35 346.64 39.35C347.14 39.35 347.54 39.75 347.54 40.25C347.54 40.75 347.14 41.15 346.64 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 63.58C346.15 63.58 345.74 63.18 345.74 62.68C345.74 62.18 346.14 61.78 346.64 61.78C347.14 61.78 347.54 62.18 347.54 62.68C347.54 63.18 347.14 63.58 346.64 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 86.02C346.15 86.02 345.74 85.62 345.74 85.12C345.74 84.62 346.14 84.22 346.64 84.22C347.14 84.22 347.54 84.62 347.54 85.12C347.54 85.62 347.14 86.02 346.64 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 108.46C346.15 108.46 345.74 108.06 345.74 107.56C345.74 107.06 346.14 106.66 346.64 106.66C347.14 106.66 347.54 107.06 347.54 107.56C347.54 108.06 347.14 108.46 346.64 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 130.9C346.15 130.9 345.74 130.5 345.74 130C345.74 129.5 346.14 129.1 346.64 129.1C347.14 129.1 347.54 129.5 347.54 130C347.54 130.5 347.14 130.9 346.64 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 153.34C346.15 153.34 345.74 152.94 345.74 152.44C345.74 151.94 346.14 151.54 346.64 151.54C347.14 151.54 347.54 151.94 347.54 152.44C347.54 152.94 347.14 153.34 346.64 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 175.77C346.15 175.77 345.74 175.37 345.74 174.87C345.74 174.37 346.14 173.97 346.64 173.97C347.14 173.97 347.54 174.37 347.54 174.87C347.54 175.37 347.14 175.77 346.64 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 198.21C346.15 198.21 345.74 197.81 345.74 197.31C345.74 196.81 346.14 196.41 346.64 196.41C347.14 196.41 347.54 196.81 347.54 197.31C347.54 197.81 347.14 198.21 346.64 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 220.65C346.15 220.65 345.74 220.25 345.74 219.75C345.74 219.25 346.14 218.85 346.64 218.85C347.14 218.85 347.54 219.25 347.54 219.75C347.54 220.25 347.14 220.65 346.64 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 243.09C346.15 243.09 345.74 242.69 345.74 242.19C345.74 241.69 346.14 241.29 346.64 241.29C347.14 241.29 347.54 241.69 347.54 242.19C347.54 242.69 347.14 243.09 346.64 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.64 265.53C346.15 265.53 345.74 265.13 345.74 264.63C345.74 264.13 346.14 263.73 346.64 263.73C347.14 263.73 347.54 264.13 347.54 264.63C347.54 265.13 347.14 265.53 346.64 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 40.25C328.47 40.75 328.87 41.15 329.37 41.15C329.87 41.15 330.26 40.75 330.26 40.25C330.26 39.75 329.86 39.35 329.37 39.35C328.88 39.35 328.47 39.75 328.47 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 62.69C328.47 63.19 328.87 63.59 329.37 63.59C329.87 63.59 330.26 63.19 330.26 62.69C330.26 62.19 329.86 61.79 329.37 61.79C328.88 61.79 328.47 62.19 328.47 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 85.12C328.47 85.62 328.87 86.02 329.37 86.02C329.87 86.02 330.26 85.62 330.26 85.12C330.26 84.62 329.86 84.22 329.37 84.22C328.88 84.22 328.47 84.62 328.47 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329.37 108.46C328.88 108.46 328.47 108.06 328.47 107.56C328.47 107.06 328.87 106.66 329.37 106.66C329.87 106.66 330.26 107.06 330.26 107.56C330.26 108.06 329.86 108.46 329.37 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 130C328.47 130.5 328.87 130.9 329.37 130.9C329.87 130.9 330.26 130.5 330.26 130C330.26 129.5 329.86 129.1 329.37 129.1C328.88 129.1 328.47 129.5 328.47 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 152.44C328.47 152.94 328.87 153.34 329.37 153.34C329.87 153.34 330.26 152.94 330.26 152.44C330.26 151.94 329.86 151.54 329.37 151.54C328.88 151.54 328.47 151.94 328.47 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329.37 175.77C328.88 175.77 328.47 175.37 328.47 174.87C328.47 174.37 328.87 173.97 329.37 173.97C329.87 173.97 330.26 174.37 330.26 174.87C330.26 175.37 329.86 175.77 329.37 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 197.31C328.47 197.81 328.87 198.21 329.37 198.21C329.87 198.21 330.26 197.81 330.26 197.31C330.26 196.81 329.86 196.41 329.37 196.41C328.88 196.41 328.47 196.81 328.47 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 219.75C328.47 220.25 328.87 220.65 329.37 220.65C329.87 220.65 330.26 220.25 330.26 219.75C330.26 219.25 329.86 218.85 329.37 218.85C328.88 218.85 328.47 219.25 328.47 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329.37 243.09C328.88 243.09 328.47 242.69 328.47 242.19C328.47 241.69 328.87 241.29 329.37 241.29C329.87 241.29 330.26 241.69 330.26 242.19C330.26 242.69 329.86 243.09 329.37 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.47 264.63C328.47 265.12 328.87 265.53 329.37 265.53C329.87 265.53 330.26 265.13 330.26 264.63C330.26 264.13 329.86 263.73 329.37 263.73C328.88 263.73 328.47 264.13 328.47 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 40.25C311.2 40.75 311.6 41.15 312.1 41.15C312.6 41.15 313 40.75 313 40.25C313 39.75 312.6 39.35 312.1 39.35C311.6 39.35 311.2 39.75 311.2 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 62.69C311.2 63.19 311.6 63.59 312.1 63.59C312.6 63.59 313 63.19 313 62.69C313 62.19 312.6 61.79 312.1 61.79C311.6 61.79 311.2 62.19 311.2 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 85.12C311.2 85.62 311.6 86.02 312.1 86.02C312.6 86.02 313 85.62 313 85.12C313 84.62 312.6 84.22 312.1 84.22C311.6 84.22 311.2 84.62 311.2 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.1 108.46C311.61 108.46 311.2 108.06 311.2 107.56C311.2 107.06 311.6 106.66 312.1 106.66C312.6 106.66 313 107.06 313 107.56C313 108.06 312.6 108.46 312.1 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 130C311.2 130.5 311.6 130.9 312.1 130.9C312.6 130.9 313 130.5 313 130C313 129.5 312.6 129.1 312.1 129.1C311.6 129.1 311.2 129.5 311.2 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 152.44C311.2 152.94 311.6 153.34 312.1 153.34C312.6 153.34 313 152.94 313 152.44C313 151.94 312.6 151.54 312.1 151.54C311.6 151.54 311.2 151.94 311.2 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.1 175.77C311.61 175.77 311.2 175.37 311.2 174.87C311.2 174.37 311.6 173.97 312.1 173.97C312.6 173.97 313 174.37 313 174.87C313 175.37 312.6 175.77 312.1 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 197.31C311.2 197.81 311.6 198.21 312.1 198.21C312.6 198.21 313 197.81 313 197.31C313 196.81 312.6 196.41 312.1 196.41C311.6 196.41 311.2 196.81 311.2 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 219.75C311.2 220.25 311.6 220.65 312.1 220.65C312.6 220.65 313 220.25 313 219.75C313 219.25 312.6 218.85 312.1 218.85C311.6 218.85 311.2 219.25 311.2 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.1 243.09C311.61 243.09 311.2 242.69 311.2 242.19C311.2 241.69 311.6 241.29 312.1 241.29C312.6 241.29 313 241.69 313 242.19C313 242.69 312.6 243.09 312.1 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.2 264.63C311.2 265.13 311.6 265.53 312.1 265.53C312.6 265.53 313 265.13 313 264.63C313 264.13 312.6 263.73 312.1 263.73C311.6 263.73 311.2 264.13 311.2 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 41.15C294.33 41.15 293.92 40.75 293.92 40.25C293.92 39.75 294.32 39.35 294.82 39.35C295.32 39.35 295.71 39.75 295.71 40.25C295.71 40.75 295.31 41.15 294.82 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 63.58C294.33 63.58 293.92 63.18 293.92 62.68C293.92 62.18 294.32 61.78 294.82 61.78C295.32 61.78 295.71 62.18 295.71 62.68C295.71 63.18 295.31 63.58 294.82 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 86.02C294.33 86.02 293.92 85.62 293.92 85.12C293.92 84.62 294.32 84.22 294.82 84.22C295.32 84.22 295.71 84.62 295.71 85.12C295.71 85.62 295.31 86.02 294.82 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 108.46C294.33 108.46 293.92 108.06 293.92 107.56C293.92 107.06 294.32 106.66 294.82 106.66C295.32 106.66 295.71 107.06 295.71 107.56C295.71 108.06 295.31 108.46 294.82 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 130.9C294.33 130.9 293.92 130.5 293.92 130C293.92 129.5 294.32 129.1 294.82 129.1C295.32 129.1 295.71 129.5 295.71 130C295.71 130.5 295.31 130.9 294.82 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 153.34C294.33 153.34 293.92 152.94 293.92 152.44C293.92 151.94 294.32 151.54 294.82 151.54C295.32 151.54 295.71 151.94 295.71 152.44C295.71 152.94 295.31 153.34 294.82 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 175.77C294.33 175.77 293.92 175.37 293.92 174.87C293.92 174.37 294.32 173.97 294.82 173.97C295.32 173.97 295.71 174.37 295.71 174.87C295.71 175.37 295.31 175.77 294.82 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 198.21C294.33 198.21 293.92 197.81 293.92 197.31C293.92 196.81 294.32 196.41 294.82 196.41C295.32 196.41 295.71 196.81 295.71 197.31C295.71 197.81 295.31 198.21 294.82 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 220.65C294.33 220.65 293.92 220.25 293.92 219.75C293.92 219.25 294.32 218.85 294.82 218.85C295.32 218.85 295.71 219.25 295.71 219.75C295.71 220.25 295.31 220.65 294.82 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 243.09C294.33 243.09 293.92 242.69 293.92 242.19C293.92 241.69 294.32 241.29 294.82 241.29C295.32 241.29 295.71 241.69 295.71 242.19C295.71 242.69 295.31 243.09 294.82 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.82 265.53C294.33 265.53 293.92 265.13 293.92 264.63C293.92 264.13 294.32 263.73 294.82 263.73C295.32 263.73 295.71 264.13 295.71 264.63C295.71 265.13 295.31 265.53 294.82 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 40.25C276.65 40.75 277.05 41.15 277.55 41.15C278.05 41.15 278.45 40.75 278.45 40.25C278.45 39.75 278.05 39.35 277.55 39.35C277.05 39.35 276.65 39.75 276.65 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 62.69C276.65 63.19 277.05 63.59 277.55 63.59C278.05 63.59 278.45 63.19 278.45 62.69C278.45 62.19 278.05 61.79 277.55 61.79C277.05 61.79 276.65 62.19 276.65 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 85.12C276.65 85.62 277.05 86.02 277.55 86.02C278.05 86.02 278.45 85.62 278.45 85.12C278.45 84.62 278.05 84.22 277.55 84.22C277.05 84.22 276.65 84.62 276.65 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.55 108.46C277.06 108.46 276.65 108.06 276.65 107.56C276.65 107.06 277.05 106.66 277.55 106.66C278.05 106.66 278.45 107.06 278.45 107.56C278.45 108.06 278.05 108.46 277.55 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 130C276.65 130.5 277.05 130.9 277.55 130.9C278.05 130.9 278.45 130.5 278.45 130C278.45 129.5 278.05 129.1 277.55 129.1C277.05 129.1 276.65 129.5 276.65 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 152.44C276.65 152.94 277.05 153.34 277.55 153.34C278.05 153.34 278.45 152.94 278.45 152.44C278.45 151.94 278.05 151.54 277.55 151.54C277.05 151.54 276.65 151.94 276.65 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.55 175.77C277.06 175.77 276.65 175.37 276.65 174.87C276.65 174.37 277.05 173.97 277.55 173.97C278.05 173.97 278.45 174.37 278.45 174.87C278.45 175.37 278.05 175.77 277.55 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 197.31C276.65 197.81 277.05 198.21 277.55 198.21C278.05 198.21 278.45 197.81 278.45 197.31C278.45 196.81 278.05 196.41 277.55 196.41C277.05 196.41 276.65 196.81 276.65 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 219.75C276.65 220.25 277.05 220.65 277.55 220.65C278.05 220.65 278.45 220.25 278.45 219.75C278.45 219.25 278.05 218.85 277.55 218.85C277.05 218.85 276.65 219.25 276.65 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.55 243.09C277.06 243.09 276.65 242.69 276.65 242.19C276.65 241.69 277.05 241.29 277.55 241.29C278.05 241.29 278.45 241.69 278.45 242.19C278.45 242.69 278.05 243.09 277.55 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.65 264.63C276.65 265.13 277.05 265.53 277.55 265.53C278.05 265.53 278.45 265.13 278.45 264.63C278.45 264.13 278.05 263.73 277.55 263.73C277.05 263.73 276.65 264.13 276.65 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 40.25C259.38 40.75 259.78 41.15 260.28 41.15C260.78 41.15 261.18 40.75 261.18 40.25C261.18 39.75 260.78 39.35 260.28 39.35C259.78 39.35 259.38 39.75 259.38 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 62.69C259.38 63.19 259.78 63.59 260.28 63.59C260.78 63.59 261.18 63.19 261.18 62.69C261.18 62.19 260.78 61.79 260.28 61.79C259.78 61.79 259.38 62.19 259.38 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 85.12C259.38 85.62 259.78 86.02 260.28 86.02C260.78 86.02 261.18 85.62 261.18 85.12C261.18 84.62 260.78 84.22 260.28 84.22C259.78 84.22 259.38 84.62 259.38 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.27 108.46C259.78 108.46 259.37 108.06 259.37 107.56C259.37 107.06 259.77 106.66 260.27 106.66C260.77 106.66 261.17 107.06 261.17 107.56C261.17 108.06 260.77 108.46 260.27 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 130C259.38 130.5 259.78 130.9 260.28 130.9C260.78 130.9 261.18 130.5 261.18 130C261.18 129.5 260.78 129.1 260.28 129.1C259.78 129.1 259.38 129.5 259.38 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 152.44C259.38 152.94 259.78 153.34 260.28 153.34C260.78 153.34 261.18 152.94 261.18 152.44C261.18 151.94 260.78 151.54 260.28 151.54C259.78 151.54 259.38 151.94 259.38 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.27 175.77C259.78 175.77 259.37 175.37 259.37 174.87C259.37 174.37 259.77 173.97 260.27 173.97C260.77 173.97 261.17 174.37 261.17 174.87C261.17 175.37 260.77 175.77 260.27 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 197.31C259.38 197.81 259.78 198.21 260.28 198.21C260.78 198.21 261.18 197.81 261.18 197.31C261.18 196.81 260.78 196.41 260.28 196.41C259.78 196.41 259.38 196.81 259.38 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 219.75C259.38 220.25 259.78 220.65 260.28 220.65C260.78 220.65 261.18 220.25 261.18 219.75C261.18 219.25 260.78 218.85 260.28 218.85C259.78 218.85 259.38 219.25 259.38 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.27 243.09C259.78 243.09 259.37 242.69 259.37 242.19C259.37 241.69 259.77 241.29 260.27 241.29C260.77 241.29 261.17 241.69 261.17 242.19C261.17 242.69 260.77 243.09 260.27 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.38 264.63C259.38 265.12 259.78 265.53 260.28 265.53C260.78 265.53 261.18 265.13 261.18 264.63C261.18 264.13 260.78 263.73 260.28 263.73C259.78 263.73 259.38 264.13 259.38 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 41.15C242.51 41.15 242.11 40.75 242.11 40.25C242.11 39.75 242.51 39.35 243 39.35C243.49 39.35 243.9 39.75 243.9 40.25C243.9 40.75 243.5 41.15 243 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 63.58C242.51 63.58 242.11 63.18 242.11 62.68C242.11 62.18 242.51 61.78 243 61.78C243.49 61.78 243.9 62.18 243.9 62.68C243.9 63.18 243.5 63.58 243 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 86.02C242.51 86.02 242.11 85.62 242.11 85.12C242.11 84.62 242.51 84.22 243 84.22C243.49 84.22 243.9 84.62 243.9 85.12C243.9 85.62 243.5 86.02 243 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 108.46C242.51 108.46 242.11 108.06 242.11 107.56C242.11 107.06 242.51 106.66 243 106.66C243.49 106.66 243.9 107.06 243.9 107.56C243.9 108.06 243.5 108.46 243 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 130.9C242.51 130.9 242.11 130.5 242.11 130C242.11 129.5 242.51 129.1 243 129.1C243.49 129.1 243.9 129.5 243.9 130C243.9 130.5 243.5 130.9 243 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 153.34C242.51 153.34 242.11 152.94 242.11 152.44C242.11 151.94 242.51 151.54 243 151.54C243.49 151.54 243.9 151.94 243.9 152.44C243.9 152.94 243.5 153.34 243 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 175.77C242.51 175.77 242.11 175.37 242.11 174.87C242.11 174.37 242.51 173.97 243 173.97C243.49 173.97 243.9 174.37 243.9 174.87C243.9 175.37 243.5 175.77 243 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 198.21C242.51 198.21 242.11 197.81 242.11 197.31C242.11 196.81 242.51 196.41 243 196.41C243.49 196.41 243.9 196.81 243.9 197.31C243.9 197.81 243.5 198.21 243 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 220.65C242.51 220.65 242.11 220.25 242.11 219.75C242.11 219.25 242.51 218.85 243 218.85C243.49 218.85 243.9 219.25 243.9 219.75C243.9 220.25 243.5 220.65 243 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 243.09C242.51 243.09 242.11 242.69 242.11 242.19C242.11 241.69 242.51 241.29 243 241.29C243.49 241.29 243.9 241.69 243.9 242.19C243.9 242.69 243.5 243.09 243 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243 265.53C242.51 265.53 242.11 265.13 242.11 264.63C242.11 264.13 242.51 263.73 243 263.73C243.49 263.73 243.9 264.13 243.9 264.63C243.9 265.13 243.5 265.53 243 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 40.25C224.83 40.75 225.23 41.15 225.72 41.15C226.21 41.15 226.62 40.75 226.62 40.25C226.62 39.75 226.22 39.35 225.72 39.35C225.22 39.35 224.83 39.75 224.83 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 62.69C224.83 63.19 225.23 63.59 225.72 63.59C226.21 63.59 226.62 63.19 226.62 62.69C226.62 62.19 226.22 61.79 225.72 61.79C225.22 61.79 224.83 62.19 224.83 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 85.12C224.83 85.62 225.23 86.02 225.72 86.02C226.21 86.02 226.62 85.62 226.62 85.12C226.62 84.62 226.22 84.22 225.72 84.22C225.22 84.22 224.83 84.62 224.83 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.73 108.46C225.24 108.46 224.84 108.06 224.84 107.56C224.84 107.06 225.24 106.66 225.73 106.66C226.22 106.66 226.63 107.06 226.63 107.56C226.63 108.06 226.23 108.46 225.73 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 130C224.83 130.5 225.23 130.9 225.72 130.9C226.21 130.9 226.62 130.5 226.62 130C226.62 129.5 226.22 129.1 225.72 129.1C225.22 129.1 224.83 129.5 224.83 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 152.44C224.83 152.94 225.23 153.34 225.72 153.34C226.21 153.34 226.62 152.94 226.62 152.44C226.62 151.94 226.22 151.54 225.72 151.54C225.22 151.54 224.83 151.94 224.83 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.73 175.77C225.24 175.77 224.84 175.37 224.84 174.87C224.84 174.37 225.24 173.97 225.73 173.97C226.22 173.97 226.63 174.37 226.63 174.87C226.63 175.37 226.23 175.77 225.73 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 197.31C224.83 197.81 225.23 198.21 225.72 198.21C226.21 198.21 226.62 197.81 226.62 197.31C226.62 196.81 226.22 196.41 225.72 196.41C225.22 196.41 224.83 196.81 224.83 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 219.75C224.83 220.25 225.23 220.65 225.72 220.65C226.21 220.65 226.62 220.25 226.62 219.75C226.62 219.25 226.22 218.85 225.72 218.85C225.22 218.85 224.83 219.25 224.83 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.73 243.09C225.24 243.09 224.84 242.69 224.84 242.19C224.84 241.69 225.24 241.29 225.73 241.29C226.22 241.29 226.63 241.69 226.63 242.19C226.63 242.69 226.23 243.09 225.73 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.83 264.63C224.83 265.13 225.23 265.53 225.72 265.53C226.21 265.53 226.62 265.13 226.62 264.63C226.62 264.13 226.22 263.73 225.72 263.73C225.22 263.73 224.83 264.13 224.83 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 40.25C207.56 40.75 207.96 41.15 208.46 41.15C208.96 41.15 209.36 40.75 209.36 40.25C209.36 39.75 208.96 39.35 208.46 39.35C207.96 39.35 207.56 39.75 207.56 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 62.69C207.56 63.19 207.96 63.59 208.46 63.59C208.96 63.59 209.36 63.19 209.36 62.69C209.36 62.19 208.96 61.79 208.46 61.79C207.96 61.79 207.56 62.19 207.56 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 85.12C207.56 85.62 207.96 86.02 208.46 86.02C208.96 86.02 209.36 85.62 209.36 85.12C209.36 84.62 208.96 84.22 208.46 84.22C207.96 84.22 207.56 84.62 207.56 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.45 108.46C207.96 108.46 207.55 108.06 207.55 107.56C207.55 107.06 207.95 106.66 208.45 106.66C208.95 106.66 209.35 107.06 209.35 107.56C209.35 108.06 208.95 108.46 208.45 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 130C207.56 130.5 207.96 130.9 208.46 130.9C208.96 130.9 209.36 130.5 209.36 130C209.36 129.5 208.96 129.1 208.46 129.1C207.96 129.1 207.56 129.5 207.56 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 152.44C207.56 152.94 207.96 153.34 208.46 153.34C208.96 153.34 209.36 152.94 209.36 152.44C209.36 151.94 208.96 151.54 208.46 151.54C207.96 151.54 207.56 151.94 207.56 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.45 175.77C207.96 175.77 207.55 175.37 207.55 174.87C207.55 174.37 207.95 173.97 208.45 173.97C208.95 173.97 209.35 174.37 209.35 174.87C209.35 175.37 208.95 175.77 208.45 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 197.31C207.56 197.81 207.96 198.21 208.46 198.21C208.96 198.21 209.36 197.81 209.36 197.31C209.36 196.81 208.96 196.41 208.46 196.41C207.96 196.41 207.56 196.81 207.56 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 219.75C207.56 220.25 207.96 220.65 208.46 220.65C208.96 220.65 209.36 220.25 209.36 219.75C209.36 219.25 208.96 218.85 208.46 218.85C207.96 218.85 207.56 219.25 207.56 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.45 243.09C207.96 243.09 207.55 242.69 207.55 242.19C207.55 241.69 207.95 241.29 208.45 241.29C208.95 241.29 209.35 241.69 209.35 242.19C209.35 242.69 208.95 243.09 208.45 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.56 264.63C207.56 265.13 207.96 265.53 208.46 265.53C208.96 265.53 209.36 265.13 209.36 264.63C209.36 264.13 208.96 263.73 208.46 263.73C207.96 263.73 207.56 264.13 207.56 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 41.15C190.69 41.15 190.28 40.75 190.28 40.25C190.28 39.75 190.68 39.35 191.18 39.35C191.68 39.35 192.08 39.75 192.08 40.25C192.08 40.75 191.68 41.15 191.18 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 63.58C190.69 63.58 190.28 63.18 190.28 62.68C190.28 62.18 190.68 61.78 191.18 61.78C191.68 61.78 192.08 62.18 192.08 62.68C192.08 63.18 191.68 63.58 191.18 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 86.02C190.69 86.02 190.28 85.62 190.28 85.12C190.28 84.62 190.68 84.22 191.18 84.22C191.68 84.22 192.08 84.62 192.08 85.12C192.08 85.62 191.68 86.02 191.18 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 108.46C190.69 108.46 190.28 108.06 190.28 107.56C190.28 107.06 190.68 106.66 191.18 106.66C191.68 106.66 192.08 107.06 192.08 107.56C192.08 108.06 191.68 108.46 191.18 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 130.9C190.69 130.9 190.28 130.5 190.28 130C190.28 129.5 190.68 129.1 191.18 129.1C191.68 129.1 192.08 129.5 192.08 130C192.08 130.5 191.68 130.9 191.18 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 153.34C190.69 153.34 190.28 152.94 190.28 152.44C190.28 151.94 190.68 151.54 191.18 151.54C191.68 151.54 192.08 151.94 192.08 152.44C192.08 152.94 191.68 153.34 191.18 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 175.77C190.69 175.77 190.28 175.37 190.28 174.87C190.28 174.37 190.68 173.97 191.18 173.97C191.68 173.97 192.08 174.37 192.08 174.87C192.08 175.37 191.68 175.77 191.18 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 198.21C190.69 198.21 190.28 197.81 190.28 197.31C190.28 196.81 190.68 196.41 191.18 196.41C191.68 196.41 192.08 196.81 192.08 197.31C192.08 197.81 191.68 198.21 191.18 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 220.65C190.69 220.65 190.28 220.25 190.28 219.75C190.28 219.25 190.68 218.85 191.18 218.85C191.68 218.85 192.08 219.25 192.08 219.75C192.08 220.25 191.68 220.65 191.18 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 243.09C190.69 243.09 190.28 242.69 190.28 242.19C190.28 241.69 190.68 241.29 191.18 241.29C191.68 241.29 192.08 241.69 192.08 242.19C192.08 242.69 191.68 243.09 191.18 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.18 265.53C190.69 265.53 190.28 265.13 190.28 264.63C190.28 264.13 190.68 263.73 191.18 263.73C191.68 263.73 192.08 264.13 192.08 264.63C192.08 265.13 191.68 265.53 191.18 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 40.25C173.01 40.75 173.41 41.15 173.91 41.15C174.41 41.15 174.81 40.75 174.81 40.25C174.81 39.75 174.41 39.35 173.91 39.35C173.41 39.35 173.01 39.75 173.01 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 62.69C173.01 63.19 173.41 63.59 173.91 63.59C174.41 63.59 174.81 63.19 174.81 62.69C174.81 62.19 174.41 61.79 173.91 61.79C173.41 61.79 173.01 62.19 173.01 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 85.12C173.01 85.62 173.41 86.02 173.91 86.02C174.41 86.02 174.81 85.62 174.81 85.12C174.81 84.62 174.41 84.22 173.91 84.22C173.41 84.22 173.01 84.62 173.01 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.9 108.46C173.41 108.46 173 108.06 173 107.56C173 107.06 173.4 106.66 173.9 106.66C174.4 106.66 174.8 107.06 174.8 107.56C174.8 108.06 174.4 108.46 173.9 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 130C173.01 130.5 173.41 130.9 173.91 130.9C174.41 130.9 174.81 130.5 174.81 130C174.81 129.5 174.41 129.1 173.91 129.1C173.41 129.1 173.01 129.5 173.01 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 152.44C173.01 152.94 173.41 153.34 173.91 153.34C174.41 153.34 174.81 152.94 174.81 152.44C174.81 151.94 174.41 151.54 173.91 151.54C173.41 151.54 173.01 151.94 173.01 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.9 175.77C173.41 175.77 173 175.37 173 174.87C173 174.37 173.4 173.97 173.9 173.97C174.4 173.97 174.8 174.37 174.8 174.87C174.8 175.37 174.4 175.77 173.9 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 197.31C173.01 197.81 173.41 198.21 173.91 198.21C174.41 198.21 174.81 197.81 174.81 197.31C174.81 196.81 174.41 196.41 173.91 196.41C173.41 196.41 173.01 196.81 173.01 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 219.75C173.01 220.25 173.41 220.65 173.91 220.65C174.41 220.65 174.81 220.25 174.81 219.75C174.81 219.25 174.41 218.85 173.91 218.85C173.41 218.85 173.01 219.25 173.01 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.9 243.09C173.41 243.09 173 242.69 173 242.19C173 241.69 173.4 241.29 173.9 241.29C174.4 241.29 174.8 241.69 174.8 242.19C174.8 242.69 174.4 243.09 173.9 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.01 264.63C173.01 265.12 173.41 265.53 173.91 265.53C174.41 265.53 174.81 265.13 174.81 264.63C174.81 264.13 174.41 263.73 173.91 263.73C173.41 263.73 173.01 264.13 173.01 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 40.25C155.73 40.75 156.13 41.15 156.63 41.15C157.13 41.15 157.53 40.75 157.53 40.25C157.53 39.75 157.13 39.35 156.63 39.35C156.13 39.35 155.73 39.75 155.73 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 62.69C155.73 63.19 156.13 63.59 156.63 63.59C157.13 63.59 157.53 63.19 157.53 62.69C157.53 62.19 157.13 61.79 156.63 61.79C156.13 61.79 155.73 62.19 155.73 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 85.12C155.73 85.62 156.13 86.02 156.63 86.02C157.13 86.02 157.53 85.62 157.53 85.12C157.53 84.62 157.13 84.22 156.63 84.22C156.13 84.22 155.73 84.62 155.73 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.63 108.46C156.14 108.46 155.73 108.06 155.73 107.56C155.73 107.06 156.13 106.66 156.63 106.66C157.13 106.66 157.53 107.06 157.53 107.56C157.53 108.06 157.13 108.46 156.63 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 130C155.73 130.5 156.13 130.9 156.63 130.9C157.13 130.9 157.53 130.5 157.53 130C157.53 129.5 157.13 129.1 156.63 129.1C156.13 129.1 155.73 129.5 155.73 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 152.44C155.73 152.94 156.13 153.34 156.63 153.34C157.13 153.34 157.53 152.94 157.53 152.44C157.53 151.94 157.13 151.54 156.63 151.54C156.13 151.54 155.73 151.94 155.73 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.63 175.77C156.14 175.77 155.73 175.37 155.73 174.87C155.73 174.37 156.13 173.97 156.63 173.97C157.13 173.97 157.53 174.37 157.53 174.87C157.53 175.37 157.13 175.77 156.63 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 197.31C155.73 197.81 156.13 198.21 156.63 198.21C157.13 198.21 157.53 197.81 157.53 197.31C157.53 196.81 157.13 196.41 156.63 196.41C156.13 196.41 155.73 196.81 155.73 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 219.75C155.73 220.25 156.13 220.65 156.63 220.65C157.13 220.65 157.53 220.25 157.53 219.75C157.53 219.25 157.13 218.85 156.63 218.85C156.13 218.85 155.73 219.25 155.73 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.63 243.09C156.14 243.09 155.73 242.69 155.73 242.19C155.73 241.69 156.13 241.29 156.63 241.29C157.13 241.29 157.53 241.69 157.53 242.19C157.53 242.69 157.13 243.09 156.63 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.73 264.63C155.73 265.12 156.13 265.53 156.63 265.53C157.13 265.53 157.53 265.13 157.53 264.63C157.53 264.13 157.13 263.73 156.63 263.73C156.13 263.73 155.73 264.13 155.73 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 41.15C138.87 41.15 138.46 40.75 138.46 40.25C138.46 39.75 138.86 39.35 139.36 39.35C139.86 39.35 140.25 39.75 140.25 40.25C140.25 40.75 139.85 41.15 139.36 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 63.58C138.87 63.58 138.46 63.18 138.46 62.68C138.46 62.18 138.86 61.78 139.36 61.78C139.86 61.78 140.25 62.18 140.25 62.68C140.25 63.18 139.85 63.58 139.36 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 86.02C138.87 86.02 138.46 85.62 138.46 85.12C138.46 84.62 138.86 84.22 139.36 84.22C139.86 84.22 140.25 84.62 140.25 85.12C140.25 85.62 139.85 86.02 139.36 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 108.46C138.87 108.46 138.46 108.06 138.46 107.56C138.46 107.06 138.86 106.66 139.36 106.66C139.86 106.66 140.25 107.06 140.25 107.56C140.25 108.06 139.85 108.46 139.36 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 130.9C138.87 130.9 138.46 130.5 138.46 130C138.46 129.5 138.86 129.1 139.36 129.1C139.86 129.1 140.25 129.5 140.25 130C140.25 130.5 139.85 130.9 139.36 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 153.34C138.87 153.34 138.46 152.94 138.46 152.44C138.46 151.94 138.86 151.54 139.36 151.54C139.86 151.54 140.25 151.94 140.25 152.44C140.25 152.94 139.85 153.34 139.36 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 175.77C138.87 175.77 138.46 175.37 138.46 174.87C138.46 174.37 138.86 173.97 139.36 173.97C139.86 173.97 140.25 174.37 140.25 174.87C140.25 175.37 139.85 175.77 139.36 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 198.21C138.87 198.21 138.46 197.81 138.46 197.31C138.46 196.81 138.86 196.41 139.36 196.41C139.86 196.41 140.25 196.81 140.25 197.31C140.25 197.81 139.85 198.21 139.36 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 220.65C138.87 220.65 138.46 220.25 138.46 219.75C138.46 219.25 138.86 218.85 139.36 218.85C139.86 218.85 140.25 219.25 140.25 219.75C140.25 220.25 139.85 220.65 139.36 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 243.09C138.87 243.09 138.46 242.69 138.46 242.19C138.46 241.69 138.86 241.29 139.36 241.29C139.86 241.29 140.25 241.69 140.25 242.19C140.25 242.69 139.85 243.09 139.36 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.36 265.53C138.87 265.53 138.46 265.13 138.46 264.63C138.46 264.13 138.86 263.73 139.36 263.73C139.86 263.73 140.25 264.13 140.25 264.63C140.25 265.13 139.85 265.53 139.36 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 40.25C121.19 40.75 121.59 41.15 122.09 41.15C122.59 41.15 122.98 40.75 122.98 40.25C122.98 39.75 122.58 39.35 122.09 39.35C121.6 39.35 121.19 39.75 121.19 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 62.69C121.19 63.19 121.59 63.59 122.09 63.59C122.59 63.59 122.98 63.19 122.98 62.69C122.98 62.19 122.58 61.79 122.09 61.79C121.6 61.79 121.19 62.19 121.19 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 85.12C121.19 85.62 121.59 86.02 122.09 86.02C122.59 86.02 122.98 85.62 122.98 85.12C122.98 84.62 122.58 84.22 122.09 84.22C121.6 84.22 121.19 84.62 121.19 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.08 108.46C121.59 108.46 121.18 108.06 121.18 107.56C121.18 107.06 121.58 106.66 122.08 106.66C122.58 106.66 122.97 107.06 122.97 107.56C122.97 108.06 122.57 108.46 122.08 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 130C121.19 130.5 121.59 130.9 122.09 130.9C122.59 130.9 122.98 130.5 122.98 130C122.98 129.5 122.58 129.1 122.09 129.1C121.6 129.1 121.19 129.5 121.19 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 152.44C121.19 152.94 121.59 153.34 122.09 153.34C122.59 153.34 122.98 152.94 122.98 152.44C122.98 151.94 122.58 151.54 122.09 151.54C121.6 151.54 121.19 151.94 121.19 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.08 175.77C121.59 175.77 121.18 175.37 121.18 174.87C121.18 174.37 121.58 173.97 122.08 173.97C122.58 173.97 122.97 174.37 122.97 174.87C122.97 175.37 122.57 175.77 122.08 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 197.31C121.19 197.81 121.59 198.21 122.09 198.21C122.59 198.21 122.98 197.81 122.98 197.31C122.98 196.81 122.58 196.41 122.09 196.41C121.6 196.41 121.19 196.81 121.19 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 219.75C121.19 220.25 121.59 220.65 122.09 220.65C122.59 220.65 122.98 220.25 122.98 219.75C122.98 219.25 122.58 218.85 122.09 218.85C121.6 218.85 121.19 219.25 121.19 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.08 243.09C121.59 243.09 121.18 242.69 121.18 242.19C121.18 241.69 121.58 241.29 122.08 241.29C122.58 241.29 122.97 241.69 122.97 242.19C122.97 242.69 122.57 243.09 122.08 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.19 264.63C121.19 265.12 121.59 265.53 122.09 265.53C122.59 265.53 122.98 265.13 122.98 264.63C122.98 264.13 122.58 263.73 122.09 263.73C121.6 263.73 121.19 264.13 121.19 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 41.15C104.32 41.15 103.91 40.75 103.91 40.25C103.91 39.75 104.31 39.35 104.81 39.35C105.31 39.35 105.71 39.75 105.71 40.25C105.71 40.75 105.31 41.15 104.81 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 63.58C104.32 63.58 103.91 63.18 103.91 62.68C103.91 62.18 104.31 61.78 104.81 61.78C105.31 61.78 105.71 62.18 105.71 62.68C105.71 63.18 105.31 63.58 104.81 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 86.02C104.32 86.02 103.91 85.62 103.91 85.12C103.91 84.62 104.31 84.22 104.81 84.22C105.31 84.22 105.71 84.62 105.71 85.12C105.71 85.62 105.31 86.02 104.81 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 108.46C104.32 108.46 103.91 108.06 103.91 107.56C103.91 107.06 104.31 106.66 104.81 106.66C105.31 106.66 105.71 107.06 105.71 107.56C105.71 108.06 105.31 108.46 104.81 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 130.9C104.32 130.9 103.91 130.5 103.91 130C103.91 129.5 104.31 129.1 104.81 129.1C105.31 129.1 105.71 129.5 105.71 130C105.71 130.5 105.31 130.9 104.81 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 153.34C104.32 153.34 103.91 152.94 103.91 152.44C103.91 151.94 104.31 151.54 104.81 151.54C105.31 151.54 105.71 151.94 105.71 152.44C105.71 152.94 105.31 153.34 104.81 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 175.77C104.32 175.77 103.91 175.37 103.91 174.87C103.91 174.37 104.31 173.97 104.81 173.97C105.31 173.97 105.71 174.37 105.71 174.87C105.71 175.37 105.31 175.77 104.81 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 198.21C104.32 198.21 103.91 197.81 103.91 197.31C103.91 196.81 104.31 196.41 104.81 196.41C105.31 196.41 105.71 196.81 105.71 197.31C105.71 197.81 105.31 198.21 104.81 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 220.65C104.32 220.65 103.91 220.25 103.91 219.75C103.91 219.25 104.31 218.85 104.81 218.85C105.31 218.85 105.71 219.25 105.71 219.75C105.71 220.25 105.31 220.65 104.81 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 243.09C104.32 243.09 103.91 242.69 103.91 242.19C103.91 241.69 104.31 241.29 104.81 241.29C105.31 241.29 105.71 241.69 105.71 242.19C105.71 242.69 105.31 243.09 104.81 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.81 265.53C104.32 265.53 103.91 265.13 103.91 264.63C103.91 264.13 104.31 263.73 104.81 263.73C105.31 263.73 105.71 264.13 105.71 264.63C105.71 265.13 105.31 265.53 104.81 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 41.15C87.05 41.15 86.64 40.75 86.64 40.25C86.64 39.75 87.04 39.35 87.54 39.35C88.04 39.35 88.44 39.75 88.44 40.25C88.44 40.75 88.04 41.15 87.54 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 63.58C87.05 63.58 86.64 63.18 86.64 62.68C86.64 62.18 87.04 61.78 87.54 61.78C88.04 61.78 88.44 62.18 88.44 62.68C88.44 63.18 88.04 63.58 87.54 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 86.02C87.05 86.02 86.64 85.62 86.64 85.12C86.64 84.62 87.04 84.22 87.54 84.22C88.04 84.22 88.44 84.62 88.44 85.12C88.44 85.62 88.04 86.02 87.54 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 108.46C87.05 108.46 86.64 108.06 86.64 107.56C86.64 107.06 87.04 106.66 87.54 106.66C88.04 106.66 88.44 107.06 88.44 107.56C88.44 108.06 88.04 108.46 87.54 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 130.9C87.05 130.9 86.64 130.5 86.64 130C86.64 129.5 87.04 129.1 87.54 129.1C88.04 129.1 88.44 129.5 88.44 130C88.44 130.5 88.04 130.9 87.54 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 153.34C87.05 153.34 86.64 152.94 86.64 152.44C86.64 151.94 87.04 151.54 87.54 151.54C88.04 151.54 88.44 151.94 88.44 152.44C88.44 152.94 88.04 153.34 87.54 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 175.77C87.05 175.77 86.64 175.37 86.64 174.87C86.64 174.37 87.04 173.97 87.54 173.97C88.04 173.97 88.44 174.37 88.44 174.87C88.44 175.37 88.04 175.77 87.54 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 198.21C87.05 198.21 86.64 197.81 86.64 197.31C86.64 196.81 87.04 196.41 87.54 196.41C88.04 196.41 88.44 196.81 88.44 197.31C88.44 197.81 88.04 198.21 87.54 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 220.65C87.05 220.65 86.64 220.25 86.64 219.75C86.64 219.25 87.04 218.85 87.54 218.85C88.04 218.85 88.44 219.25 88.44 219.75C88.44 220.25 88.04 220.65 87.54 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 243.09C87.05 243.09 86.64 242.69 86.64 242.19C86.64 241.69 87.04 241.29 87.54 241.29C88.04 241.29 88.44 241.69 88.44 242.19C88.44 242.69 88.04 243.09 87.54 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.54 265.53C87.05 265.53 86.64 265.13 86.64 264.63C86.64 264.13 87.04 263.73 87.54 263.73C88.04 263.73 88.44 264.13 88.44 264.63C88.44 265.13 88.04 265.53 87.54 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 40.25C69.37 40.75 69.77 41.15 70.27 41.15C70.77 41.15 71.17 40.75 71.17 40.25C71.17 39.75 70.77 39.35 70.27 39.35C69.77 39.35 69.37 39.75 69.37 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 62.69C69.37 63.19 69.77 63.59 70.27 63.59C70.77 63.59 71.17 63.19 71.17 62.69C71.17 62.19 70.77 61.79 70.27 61.79C69.77 61.79 69.37 62.19 69.37 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 85.12C69.37 85.62 69.77 86.02 70.27 86.02C70.77 86.02 71.17 85.62 71.17 85.12C71.17 84.62 70.77 84.22 70.27 84.22C69.77 84.22 69.37 84.62 69.37 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.26 108.46C69.77 108.46 69.36 108.06 69.36 107.56C69.36 107.06 69.76 106.66 70.26 106.66C70.76 106.66 71.16 107.06 71.16 107.56C71.16 108.06 70.76 108.46 70.26 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 130C69.37 130.5 69.77 130.9 70.27 130.9C70.77 130.9 71.17 130.5 71.17 130C71.17 129.5 70.77 129.1 70.27 129.1C69.77 129.1 69.37 129.5 69.37 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 152.44C69.37 152.94 69.77 153.34 70.27 153.34C70.77 153.34 71.17 152.94 71.17 152.44C71.17 151.94 70.77 151.54 70.27 151.54C69.77 151.54 69.37 151.94 69.37 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.26 175.77C69.77 175.77 69.36 175.37 69.36 174.87C69.36 174.37 69.76 173.97 70.26 173.97C70.76 173.97 71.16 174.37 71.16 174.87C71.16 175.37 70.76 175.77 70.26 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 197.31C69.37 197.81 69.77 198.21 70.27 198.21C70.77 198.21 71.17 197.81 71.17 197.31C71.17 196.81 70.77 196.41 70.27 196.41C69.77 196.41 69.37 196.81 69.37 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 219.75C69.37 220.25 69.77 220.65 70.27 220.65C70.77 220.65 71.17 220.25 71.17 219.75C71.17 219.25 70.77 218.85 70.27 218.85C69.77 218.85 69.37 219.25 69.37 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.26 243.09C69.77 243.09 69.36 242.69 69.36 242.19C69.36 241.69 69.76 241.29 70.26 241.29C70.76 241.29 71.16 241.69 71.16 242.19C71.16 242.69 70.76 243.09 70.26 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.37 264.63C69.37 265.12 69.77 265.53 70.27 265.53C70.77 265.53 71.17 265.13 71.17 264.63C71.17 264.13 70.77 263.73 70.27 263.73C69.77 263.73 69.37 264.13 69.37 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 41.15C52.5 41.15 52.09 40.75 52.09 40.25C52.09 39.75 52.49 39.35 52.99 39.35C53.49 39.35 53.89 39.75 53.89 40.25C53.89 40.75 53.49 41.15 52.99 41.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 63.58C52.5 63.58 52.09 63.18 52.09 62.68C52.09 62.18 52.49 61.78 52.99 61.78C53.49 61.78 53.89 62.18 53.89 62.68C53.89 63.18 53.49 63.58 52.99 63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 86.02C52.5 86.02 52.09 85.62 52.09 85.12C52.09 84.62 52.49 84.22 52.99 84.22C53.49 84.22 53.89 84.62 53.89 85.12C53.89 85.62 53.49 86.02 52.99 86.02Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 108.46C52.5 108.46 52.09 108.06 52.09 107.56C52.09 107.06 52.49 106.66 52.99 106.66C53.49 106.66 53.89 107.06 53.89 107.56C53.89 108.06 53.49 108.46 52.99 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 130.9C52.5 130.9 52.09 130.5 52.09 130C52.09 129.5 52.49 129.1 52.99 129.1C53.49 129.1 53.89 129.5 53.89 130C53.89 130.5 53.49 130.9 52.99 130.9Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 153.34C52.5 153.34 52.09 152.94 52.09 152.44C52.09 151.94 52.49 151.54 52.99 151.54C53.49 151.54 53.89 151.94 53.89 152.44C53.89 152.94 53.49 153.34 52.99 153.34Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 175.77C52.5 175.77 52.09 175.37 52.09 174.87C52.09 174.37 52.49 173.97 52.99 173.97C53.49 173.97 53.89 174.37 53.89 174.87C53.89 175.37 53.49 175.77 52.99 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 198.21C52.5 198.21 52.09 197.81 52.09 197.31C52.09 196.81 52.49 196.41 52.99 196.41C53.49 196.41 53.89 196.81 53.89 197.31C53.89 197.81 53.49 198.21 52.99 198.21Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 220.65C52.5 220.65 52.09 220.25 52.09 219.75C52.09 219.25 52.49 218.85 52.99 218.85C53.49 218.85 53.89 219.25 53.89 219.75C53.89 220.25 53.49 220.65 52.99 220.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 243.09C52.5 243.09 52.09 242.69 52.09 242.19C52.09 241.69 52.49 241.29 52.99 241.29C53.49 241.29 53.89 241.69 53.89 242.19C53.89 242.69 53.49 243.09 52.99 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.99 265.53C52.5 265.53 52.09 265.13 52.09 264.63C52.09 264.13 52.49 263.73 52.99 263.73C53.49 263.73 53.89 264.13 53.89 264.63C53.89 265.13 53.49 265.53 52.99 265.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 40.25C34.82 40.75 35.22 41.15 35.72 41.15C36.22 41.15 36.62 40.75 36.62 40.25C36.62 39.75 36.22 39.35 35.72 39.35C35.22 39.35 34.82 39.75 34.82 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 62.69C34.82 63.19 35.22 63.59 35.72 63.59C36.22 63.59 36.62 63.19 36.62 62.69C36.62 62.19 36.22 61.79 35.72 61.79C35.22 61.79 34.82 62.19 34.82 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 85.12C34.82 85.62 35.22 86.02 35.72 86.02C36.22 86.02 36.62 85.62 36.62 85.12C36.62 84.62 36.22 84.22 35.72 84.22C35.22 84.22 34.82 84.62 34.82 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.71 108.46C35.22 108.46 34.81 108.06 34.81 107.56C34.81 107.06 35.21 106.66 35.71 106.66C36.21 106.66 36.61 107.06 36.61 107.56C36.61 108.06 36.21 108.46 35.71 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 130C34.82 130.5 35.22 130.9 35.72 130.9C36.22 130.9 36.62 130.5 36.62 130C36.62 129.5 36.22 129.1 35.72 129.1C35.22 129.1 34.82 129.5 34.82 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 152.44C34.82 152.94 35.22 153.34 35.72 153.34C36.22 153.34 36.62 152.94 36.62 152.44C36.62 151.94 36.22 151.54 35.72 151.54C35.22 151.54 34.82 151.94 34.82 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.71 175.77C35.22 175.77 34.81 175.37 34.81 174.87C34.81 174.37 35.21 173.97 35.71 173.97C36.21 173.97 36.61 174.37 36.61 174.87C36.61 175.37 36.21 175.77 35.71 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 197.31C34.82 197.81 35.22 198.21 35.72 198.21C36.22 198.21 36.62 197.81 36.62 197.31C36.62 196.81 36.22 196.41 35.72 196.41C35.22 196.41 34.82 196.81 34.82 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 219.75C34.82 220.25 35.22 220.65 35.72 220.65C36.22 220.65 36.62 220.25 36.62 219.75C36.62 219.25 36.22 218.85 35.72 218.85C35.22 218.85 34.82 219.25 34.82 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.71 243.09C35.22 243.09 34.81 242.69 34.81 242.19C34.81 241.69 35.21 241.29 35.71 241.29C36.21 241.29 36.61 241.69 36.61 242.19C36.61 242.69 36.21 243.09 35.71 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.82 264.63C34.82 265.12 35.22 265.53 35.72 265.53C36.22 265.53 36.62 265.13 36.62 264.63C36.62 264.13 36.22 263.73 35.72 263.73C35.22 263.73 34.82 264.13 34.82 264.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 40.25C17.54 40.75 17.94 41.15 18.44 41.15C18.94 41.15 19.34 40.75 19.34 40.25C19.34 39.75 18.94 39.35 18.44 39.35C17.94 39.35 17.54 39.75 17.54 40.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 62.69C17.54 63.19 17.94 63.59 18.44 63.59C18.94 63.59 19.34 63.19 19.34 62.69C19.34 62.19 18.94 61.79 18.44 61.79C17.94 61.79 17.54 62.19 17.54 62.69Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 85.12C17.54 85.62 17.94 86.02 18.44 86.02C18.94 86.02 19.34 85.62 19.34 85.12C19.34 84.62 18.94 84.22 18.44 84.22C17.94 84.22 17.54 84.62 17.54 85.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.44 108.46C17.95 108.46 17.54 108.06 17.54 107.56C17.54 107.06 17.94 106.66 18.44 106.66C18.94 106.66 19.34 107.06 19.34 107.56C19.34 108.06 18.94 108.46 18.44 108.46Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 130C17.54 130.5 17.94 130.9 18.44 130.9C18.94 130.9 19.34 130.5 19.34 130C19.34 129.5 18.94 129.1 18.44 129.1C17.94 129.1 17.54 129.5 17.54 130Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 152.44C17.54 152.94 17.94 153.34 18.44 153.34C18.94 153.34 19.34 152.94 19.34 152.44C19.34 151.94 18.94 151.54 18.44 151.54C17.94 151.54 17.54 151.94 17.54 152.44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.44 175.77C17.95 175.77 17.54 175.37 17.54 174.87C17.54 174.37 17.94 173.97 18.44 173.97C18.94 173.97 19.34 174.37 19.34 174.87C19.34 175.37 18.94 175.77 18.44 175.77Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 197.31C17.54 197.81 17.94 198.21 18.44 198.21C18.94 198.21 19.34 197.81 19.34 197.31C19.34 196.81 18.94 196.41 18.44 196.41C17.94 196.41 17.54 196.81 17.54 197.31Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 219.75C17.54 220.25 17.94 220.65 18.44 220.65C18.94 220.65 19.34 220.25 19.34 219.75C19.34 219.25 18.94 218.85 18.44 218.85C17.94 218.85 17.54 219.25 17.54 219.75Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.44 243.09C17.95 243.09 17.54 242.69 17.54 242.19C17.54 241.69 17.94 241.29 18.44 241.29C18.94 241.29 19.34 241.69 19.34 242.19C19.34 242.69 18.94 243.09 18.44 243.09Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.54 264.63C17.54 265.13 17.94 265.53 18.44 265.53C18.94 265.53 19.34 265.13 19.34 264.63C19.34 264.13 18.94 263.73 18.44 263.73C17.94 263.73 17.54 264.13 17.54 264.63Z",
    fill: "#F6F6F6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481 35.04H5V10.01C5 7.24 7.24 5 10.01 5H475.98C478.75 5 480.99 7.24 480.99 10.01V35.03L481 35.04Z",
    fill: "url(#paint1_linear_346_1217)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M20.03 24.95C22.7527 24.95 24.96 22.7428 24.96 20.02C24.96 17.2973 22.7527 15.09 20.03 15.09C17.3072 15.09 15.1 17.2973 15.1 20.02C15.1 22.7428 17.3072 24.95 20.03 24.95Z",
    fill: "#F6F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M33.72 24.95C36.4427 24.95 38.65 22.7428 38.65 20.02C38.65 17.2973 36.4427 15.09 33.72 15.09C30.9972 15.09 28.79 17.2973 28.79 20.02C28.79 22.7428 30.9972 24.95 33.72 24.95Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.41 24.95C50.1327 24.95 52.34 22.7428 52.34 20.02C52.34 17.2973 50.1327 15.09 47.41 15.09C44.6872 15.09 42.48 17.2973 42.48 20.02C42.48 22.7428 44.6872 24.95 47.41 24.95Z",
    fill: "#F6F6F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.07 45.48H18.81C16.7058 45.48 15 47.1858 15 49.29V254.19C15 256.294 16.7058 258 18.81 258H50.07C52.1742 258 53.88 256.294 53.88 254.19V49.29C53.88 47.1858 52.1742 45.48 50.07 45.48Z",
    fill: "url(#paint2_linear_346_1217)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 90.25H29.43C28.0437 90.25 26.92 91.3738 26.92 92.76V102.78C26.92 104.166 28.0437 105.29 29.43 105.29H39.45C40.8362 105.29 41.96 104.166 41.96 102.78V92.76C41.96 91.3738 40.8362 90.25 39.45 90.25Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 94,
    width: 9,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 94.01H30.68V101.53H38.2V94.01Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.18 96.41L34.44 94.17L30.7 96.41L34.44 98.66L38.18 96.41ZM34.44 94.89L36.96 96.41L34.44 97.93L31.92 96.41L34.44 94.89Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2 98.39L34.44 100.65L30.68 98.39V99.12L34.44 101.38L38.2 99.12V98.39Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2 97.03L37.41 97.5L34.44 99.28L31.47 97.5L30.68 97.03V97.76L34.44 100.02L38.2 97.76V97.03Z",
    fill: "#F6F6F6"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 111.84H29.43C28.0437 111.84 26.92 112.964 26.92 114.35V124.37C26.92 125.756 28.0437 126.88 29.43 126.88H39.45C40.8362 126.88 41.96 125.756 41.96 124.37V114.35C41.96 112.964 40.8362 111.84 39.45 111.84Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 115,
    width: 9,
    height: 9
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 115.6H30.68V123.12H38.2V115.6Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.04 118.12C35.95 118.14 35.87 118.19 35.81 118.26C35.75 118.33 35.71 118.42 35.7 118.51C35.69 118.6 35.7 118.7 35.74 118.78C35.78 118.86 35.85 118.93 35.93 118.98C36.01 119.03 36.1 119.05 36.2 119.04C36.29 119.04 36.38 119 36.46 118.94C36.53 118.88 36.59 118.81 36.62 118.72C36.65 118.63 36.65 118.54 36.62 118.45C36.6 118.39 36.58 118.33 36.54 118.29C36.5 118.24 36.46 118.2 36.4 118.17C36.35 118.14 36.29 118.12 36.23 118.11C36.17 118.11 36.11 118.11 36.05 118.12H36.04Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.48 117.18C34.39 117.2 34.31 117.25 34.25 117.32C34.19 117.39 34.15 117.48 34.14 117.57C34.13 117.66 34.14 117.76 34.18 117.84C34.22 117.92 34.29 117.99 34.37 118.04C34.45 118.09 34.54 118.11 34.64 118.1C34.73 118.1 34.82 118.06 34.9 118C34.97 117.94 35.03 117.87 35.06 117.78C35.09 117.69 35.09 117.6 35.06 117.51C35.04 117.45 35.02 117.39 34.98 117.35C34.94 117.3 34.9 117.26 34.84 117.23C34.79 117.2 34.73 117.18 34.67 117.17C34.61 117.17 34.55 117.17 34.49 117.18H34.48Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.91 118.12C32.82 118.14 32.74 118.19 32.68 118.26C32.62 118.33 32.58 118.42 32.57 118.51C32.56 118.6 32.57 118.7 32.61 118.78C32.65 118.86 32.72 118.93 32.8 118.98C32.88 119.03 32.97 119.05 33.07 119.04C33.16 119.04 33.25 119 33.33 118.94C33.4 118.88 33.46 118.81 33.49 118.72C33.52 118.63 33.52 118.54 33.49 118.45C33.47 118.39 33.45 118.33 33.41 118.29C33.37 118.24 33.33 118.2 33.27 118.17C33.22 118.14 33.16 118.12 33.1 118.11C33.04 118.11 32.98 118.11 32.92 118.12H32.91Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.91 120C32.82 120.02 32.74 120.07 32.68 120.14C32.62 120.21 32.58 120.3 32.57 120.39C32.56 120.48 32.57 120.58 32.61 120.66C32.65 120.74 32.72 120.81 32.8 120.86C32.88 120.91 32.97 120.93 33.07 120.92C33.16 120.92 33.25 120.88 33.33 120.82C33.4 120.76 33.46 120.69 33.49 120.6C33.52 120.51 33.52 120.42 33.49 120.33C33.47 120.27 33.45 120.21 33.41 120.17C33.37 120.12 33.33 120.08 33.27 120.05C33.22 120.02 33.16 120 33.1 119.99C33.04 119.99 32.98 119.99 32.92 120H32.91Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6 115.6C34.1 115.58 33.59 115.67 33.12 115.85C32.65 116.03 32.22 116.31 31.86 116.66C31.5 117.01 31.21 117.43 31.01 117.9C30.81 118.36 30.71 118.86 30.71 119.37C30.71 120.37 31.11 121.32 31.81 122.03C32.52 122.74 33.47 123.13 34.47 123.13C34.58 123.13 34.68 123.13 34.78 123.11C34.86 123.11 34.93 123.07 34.98 123.01C35.03 122.95 35.06 122.88 35.06 122.8V121.68C35.05 121.46 35.11 121.24 35.23 121.05C35.35 120.86 35.53 120.72 35.73 120.63C35.93 120.54 36.16 120.52 36.38 120.56C36.6 120.6 36.8 120.71 36.96 120.87L36.99 120.9C37.06 120.97 37.15 121.02 37.25 121.05C37.35 121.08 37.45 121.08 37.55 121.06C37.65 121.04 37.74 121 37.81 120.93C37.89 120.87 37.94 120.78 37.98 120.69C38.15 120.24 38.24 119.75 38.22 119.27C38.18 118.32 37.79 117.41 37.12 116.73C36.45 116.05 35.55 115.65 34.59 115.61L34.6 115.6ZM37.41 120.43C37.17 120.18 36.85 120.01 36.51 119.95C36.17 119.88 35.82 119.92 35.5 120.05C35.18 120.18 34.91 120.41 34.72 120.7C34.53 120.99 34.43 121.33 34.43 121.67V122.49C33.61 122.49 32.81 122.15 32.23 121.56C31.64 120.97 31.32 120.17 31.32 119.34C31.32 118.51 31.66 117.71 32.25 117.13C32.84 116.54 33.64 116.22 34.47 116.22C34.51 116.22 34.54 116.22 34.58 116.22C35.37 116.26 36.13 116.59 36.69 117.16C37.25 117.73 37.58 118.48 37.61 119.28C37.62 119.67 37.56 120.06 37.42 120.42L37.41 120.43Z",
    fill: "#F6F6F6"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 219.78H29.43C28.0437 219.78 26.92 220.904 26.92 222.29V232.31C26.92 233.696 28.0437 234.82 29.43 234.82H39.45C40.8362 234.82 41.96 233.696 41.96 232.31V222.29C41.96 220.904 40.8362 219.78 39.45 219.78Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 223,
    width: 9,
    height: 9
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 223.54H30.68V231.06H38.2V223.54Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2 224.48H34.75V225.96L33.91 224.51C33.85 224.41 33.78 224.34 33.68 224.28C33.58 224.22 33.48 224.2 33.37 224.2C33.26 224.2 33.15 224.23 33.06 224.28C32.96 224.34 32.89 224.41 32.83 224.51L30.68 228.24H32.97C32.87 228.58 32.85 228.94 32.92 229.29C32.99 229.64 33.14 229.97 33.36 230.24C33.58 230.52 33.87 230.74 34.2 230.88C34.53 231.02 34.88 231.08 35.24 231.05C35.6 231.02 35.94 230.91 36.24 230.72C36.54 230.53 36.79 230.27 36.97 229.96C37.15 229.65 37.25 229.3 37.26 228.95C37.27 228.59 37.2 228.24 37.05 227.92H38.2V224.47V224.48ZM31.77 227.61L33.38 224.82L34.49 226.75C34 226.89 33.56 227.19 33.27 227.61H31.77ZM35.07 230.43C34.76 230.43 34.46 230.34 34.2 230.17C33.94 230 33.74 229.75 33.62 229.47C33.5 229.18 33.47 228.87 33.53 228.56C33.59 228.26 33.74 227.98 33.96 227.76C34.18 227.54 34.46 227.39 34.76 227.33C35.06 227.27 35.38 227.3 35.67 227.42C35.96 227.54 36.2 227.74 36.37 228C36.54 228.26 36.63 228.56 36.63 228.87C36.63 229.29 36.46 229.68 36.17 229.98C35.88 230.27 35.48 230.44 35.06 230.44L35.07 230.43ZM37.58 227.3H36.61C36.28 226.97 35.85 226.76 35.39 226.7V225.11H37.58V227.3Z",
    fill: "#F6F6F6"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 198.19H29.43C28.0437 198.19 26.92 199.314 26.92 200.7V210.72C26.92 212.106 28.0437 213.23 29.43 213.23H39.45C40.8362 213.23 41.96 212.106 41.96 210.72V200.7C41.96 199.314 40.8362 198.19 39.45 198.19Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 201,
    width: 9,
    height: 9
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 201.95H30.68V209.47H38.2V201.95Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.26 201.95H31.62C31.37 201.95 31.13 202.05 30.96 202.23C30.79 202.41 30.68 202.65 30.68 202.89V209.47H38.2V202.89C38.2 202.64 38.1 202.4 37.92 202.23C37.74 202.05 37.5 201.95 37.26 201.95ZM37.58 208.85H31.31V202.9C31.31 202.82 31.34 202.74 31.4 202.68C31.46 202.62 31.54 202.59 31.62 202.59H37.26C37.34 202.59 37.42 202.62 37.48 202.68C37.54 202.74 37.57 202.82 37.57 202.9V208.85H37.58ZM32.56 203.83H36.32V205.08H35.69V204.45H34.75V206.96H35.38V207.59H33.5V206.96H34.13V204.45H33.19V205.08H32.56V203.83Z",
    fill: "#F6F6F6"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 133.42H29.43C28.0437 133.42 26.92 134.544 26.92 135.93V145.95C26.92 147.336 28.0437 148.46 29.43 148.46H39.45C40.8362 148.46 41.96 147.336 41.96 145.95V135.93C41.96 134.544 40.8362 133.42 39.45 133.42Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 137,
    width: 9,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 137.19H30.68V144.71H38.2V137.19Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.19 137.19H31.62C31.37 137.19 31.13 137.29 30.96 137.47C30.79 137.65 30.68 137.89 30.68 138.13V139.7H31.62V140.64H32.24V139.7H33.19V138.75H34.13V138.13H33.19V137.19Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.26 137.19H35.69V138.13H34.75V138.75H35.69V139.7H36.63V140.64H37.25V139.7H38.19V138.13C38.19 137.88 38.09 137.64 37.91 137.47C37.73 137.3 37.49 137.19 37.25 137.19H37.26Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.27 141.26H36.64V142.2H35.7V143.15H34.76V143.77H35.7V144.71H37.27C37.52 144.71 37.76 144.61 37.93 144.43C38.11 144.25 38.21 144.01 38.21 143.77V142.2H37.27V141.26Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.19 142.2H32.25V141.26H31.63V142.2H30.69V143.77C30.69 144.02 30.79 144.26 30.97 144.43C31.15 144.61 31.39 144.71 31.63 144.71H33.2V143.77H34.14V143.15H33.2V142.2H33.19Z",
    fill: "#F6F6F6"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 155.01H29.43C28.0437 155.01 26.92 156.134 26.92 157.52V167.54C26.92 168.926 28.0437 170.05 29.43 170.05H39.45C40.8362 170.05 41.96 168.926 41.96 167.54V157.52C41.96 156.134 40.8362 155.01 39.45 155.01Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 158,
    width: 9,
    height: 9
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 158.77H30.68V166.29H38.2V158.77Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.58 164.21V160.86C37.95 160.68 38.21 160.31 38.21 159.87C38.21 159.27 37.72 158.77 37.11 158.77C36.67 158.77 36.3 159.03 36.12 159.4H32.77C32.59 159.03 32.22 158.77 31.78 158.77C31.18 158.77 30.68 159.26 30.68 159.87C30.68 160.31 30.94 160.68 31.31 160.86V164.21C30.94 164.39 30.68 164.76 30.68 165.2C30.68 165.8 31.17 166.3 31.78 166.3C32.22 166.3 32.59 166.04 32.77 165.67H36.12C36.3 166.04 36.67 166.3 37.11 166.3C37.71 166.3 38.21 165.81 38.21 165.2C38.21 164.76 37.95 164.39 37.58 164.21ZM36.02 165.04H32.85C32.78 164.56 32.4 164.19 31.93 164.12V160.95C32.41 160.88 32.78 160.5 32.85 160.03H36.02C36.09 160.51 36.47 160.88 36.94 160.95V164.12C36.46 164.19 36.09 164.57 36.02 165.04ZM37.11 159.4C37.37 159.4 37.58 159.61 37.58 159.87C37.58 160.13 37.37 160.34 37.11 160.34C36.85 160.34 36.64 160.13 36.64 159.87C36.64 159.61 36.85 159.4 37.11 159.4ZM31.78 159.4C32.04 159.4 32.25 159.61 32.25 159.87C32.25 160.13 32.04 160.34 31.78 160.34C31.52 160.34 31.31 160.13 31.31 159.87C31.31 159.61 31.52 159.4 31.78 159.4ZM31.78 165.67C31.52 165.67 31.31 165.46 31.31 165.2C31.31 164.94 31.52 164.73 31.78 164.73C32.04 164.73 32.25 164.94 32.25 165.2C32.25 165.46 32.04 165.67 31.78 165.67ZM37.11 165.67C36.85 165.67 36.64 165.46 36.64 165.2C36.64 164.94 36.85 164.73 37.11 164.73C37.37 164.73 37.58 164.94 37.58 165.2C37.58 165.46 37.37 165.67 37.11 165.67ZM35.07 162.22V161.59C35.07 161.24 34.79 160.96 34.44 160.96H33.19C32.84 160.96 32.56 161.24 32.56 161.59V162.22C32.56 162.57 32.84 162.85 33.19 162.85H34.44C34.79 162.85 35.07 162.57 35.07 162.22ZM33.19 161.59H34.44V162.22H33.19V161.59ZM36.32 162.85V163.48C36.32 163.83 36.04 164.11 35.69 164.11H34.44C34.09 164.11 33.81 163.83 33.81 163.48H35.69V162.23C36.04 162.23 36.32 162.51 36.32 162.86V162.85Z",
    fill: "#F6F6F6"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 176.6H29.43C28.0437 176.6 26.92 177.724 26.92 179.11V189.13C26.92 190.516 28.0437 191.64 29.43 191.64H39.45C40.8362 191.64 41.96 190.516 41.96 189.13V179.11C41.96 177.724 40.8362 176.6 39.45 176.6Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 180,
    width: 9,
    height: 8
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 180.36H30.68V187.88H38.2V180.36Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.26 185.38V184.13C37.26 183.71 37.16 183.29 36.98 182.91C36.8 182.53 36.53 182.2 36.2 181.93H37.03C37.1 182.05 37.21 182.14 37.33 182.19C37.46 182.24 37.6 182.25 37.73 182.21C37.86 182.17 37.98 182.09 38.06 181.99C38.14 181.88 38.19 181.75 38.19 181.61C38.19 181.47 38.14 181.34 38.06 181.23C37.98 181.12 37.86 181.04 37.73 181.01C37.6 180.97 37.46 180.98 37.33 181.04C37.2 181.09 37.1 181.19 37.03 181.3H35.65C35.58 181.03 35.43 180.79 35.21 180.62C34.99 180.45 34.72 180.36 34.44 180.36C34.16 180.36 33.89 180.45 33.67 180.62C33.45 180.79 33.3 181.03 33.23 181.3H31.85C31.78 181.18 31.67 181.09 31.55 181.04C31.42 180.99 31.28 180.98 31.15 181.02C31.02 181.06 30.9 181.14 30.82 181.24C30.74 181.35 30.69 181.48 30.69 181.62C30.69 181.76 30.74 181.89 30.82 182C30.9 182.11 31.02 182.19 31.15 182.22C31.28 182.26 31.42 182.25 31.55 182.19C31.68 182.14 31.78 182.04 31.85 181.93H32.68C32.35 182.19 32.08 182.53 31.9 182.91C31.72 183.29 31.62 183.71 31.62 184.13V185.38H30.68V186.95C30.68 187.2 30.78 187.44 30.96 187.61C31.14 187.78 31.38 187.89 31.62 187.89H33.19V185.38H32.25V184.13C32.25 183.74 32.35 183.37 32.55 183.03C32.74 182.7 33.02 182.42 33.36 182.23C33.47 182.43 33.62 182.59 33.82 182.7C34.01 182.81 34.23 182.87 34.45 182.87C34.67 182.87 34.89 182.81 35.08 182.7C35.27 182.59 35.43 182.42 35.54 182.23C35.87 182.42 36.15 182.7 36.35 183.03C36.54 183.36 36.65 183.74 36.65 184.13V185.38H35.71V187.89H37.28C37.53 187.89 37.77 187.79 37.94 187.61C38.12 187.43 38.22 187.19 38.22 186.95V185.38H37.28H37.26ZM32.56 187.26H31.62C31.54 187.26 31.46 187.23 31.4 187.17C31.34 187.11 31.31 187.03 31.31 186.95V186.01H32.56V187.26ZM34.44 182.24C34.32 182.24 34.19 182.2 34.09 182.13C33.99 182.06 33.91 181.96 33.86 181.85C33.81 181.74 33.8 181.61 33.82 181.49C33.84 181.37 33.9 181.26 33.99 181.17C34.08 181.08 34.19 181.02 34.31 181C34.43 180.98 34.56 180.99 34.67 181.04C34.78 181.09 34.88 181.17 34.95 181.27C35.02 181.37 35.06 181.49 35.06 181.62C35.06 181.79 34.99 181.95 34.88 182.06C34.76 182.18 34.6 182.24 34.44 182.24ZM37.58 186.94C37.58 187.02 37.55 187.1 37.49 187.16C37.43 187.22 37.35 187.25 37.27 187.25H36.33V186H37.58V186.94Z",
    fill: "#F6F6F6"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.45 68.66H29.43C28.0437 68.66 26.92 69.7838 26.92 71.17V81.19C26.92 82.5763 28.0437 83.7 29.43 83.7H39.45C40.8362 83.7 41.96 82.5763 41.96 81.19V71.17C41.96 69.7838 40.8362 68.66 39.45 68.66Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 72,
    width: 9,
    height: 8
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 72.42H30.68V79.94H38.2V72.42Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.01 75.87H36.64V78.38H36.01V75.87ZM36.87 75.08L37.31 74.19L38.2 73.75L37.31 73.31L36.87 72.42L36.43 73.31L35.54 73.75L36.43 74.19L36.87 75.08ZM34.31 74.53L35.38 78.38H34.74L34.47 77.44H32.84L32.57 78.38H31.93L33.01 74.51C33.05 74.32 33.18 74.16 33.35 74.07C33.53 73.98 33.73 73.97 33.93 74.05C34.11 74.13 34.26 74.31 34.31 74.53ZM34.3 76.81L33.7 74.67C33.7 74.67 33.64 74.63 33.63 74.67L33.03 76.81H34.31H34.3ZM37.58 79.32H31.31V73.37C31.31 73.2 31.45 73.06 31.62 73.06H35.07V72.43H31.62C31.1 72.43 30.68 72.85 30.68 73.37V79.95H38.2V75.25H37.57V79.32H37.58Z",
    fill: "#F6F6F6"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M465.4 45.48H382.95C379.675 45.48 377.02 48.1349 377.02 51.41V252.07C377.02 255.345 379.675 258 382.95 258H465.4C468.675 258 471.33 255.345 471.33 252.07V51.41C471.33 48.1349 468.675 45.48 465.4 45.48Z",
    fill: "url(#paint3_linear_346_1217)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 76.88H388.85C387.464 76.88 386.34 78.0038 386.34 79.39V89.41C386.34 90.7962 387.464 91.92 388.85 91.92H398.87C400.256 91.92 401.38 90.7962 401.38 89.41V79.39C401.38 78.0038 400.256 76.88 398.87 76.88Z",
    fill: "#F6F6F6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 79.38H405.07C404.186 79.38 403.47 80.0964 403.47 80.98V87.83C403.47 88.7137 404.186 89.43 405.07 89.43H460.41C461.294 89.43 462.01 88.7137 462.01 87.83V80.98C462.01 80.0964 461.294 79.38 460.41 79.38Z",
    fill: "#F6F6F6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 99.14H388.85C387.464 99.14 386.34 100.264 386.34 101.65V111.67C386.34 113.056 387.464 114.18 388.85 114.18H398.87C400.256 114.18 401.38 113.056 401.38 111.67V101.65C401.38 100.264 400.256 99.14 398.87 99.14Z",
    fill: "#F6F6F6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 101.64H405.07C404.186 101.64 403.47 102.356 403.47 103.24V110.09C403.47 110.974 404.186 111.69 405.07 111.69H460.41C461.294 111.69 462.01 110.974 462.01 110.09V103.24C462.01 102.356 461.294 101.64 460.41 101.64Z",
    fill: "#F6F6F6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 121.39H388.85C387.464 121.39 386.34 122.514 386.34 123.9V133.92C386.34 135.306 387.464 136.43 388.85 136.43H398.87C400.256 136.43 401.38 135.306 401.38 133.92V123.9C401.38 122.514 400.256 121.39 398.87 121.39Z",
    fill: "#F6F6F6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 123.89H405.07C404.186 123.89 403.47 124.606 403.47 125.49V132.34C403.47 133.224 404.186 133.94 405.07 133.94H460.41C461.294 133.94 462.01 133.224 462.01 132.34V125.49C462.01 124.606 461.294 123.89 460.41 123.89Z",
    fill: "#F6F6F6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 143.65H388.85C387.464 143.65 386.34 144.774 386.34 146.16V156.18C386.34 157.566 387.464 158.69 388.85 158.69H398.87C400.256 158.69 401.38 157.566 401.38 156.18V146.16C401.38 144.774 400.256 143.65 398.87 143.65Z",
    fill: "#F6F6F6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 146.15H405.07C404.186 146.15 403.47 146.866 403.47 147.75V154.6C403.47 155.484 404.186 156.2 405.07 156.2H460.41C461.294 156.2 462.01 155.484 462.01 154.6V147.75C462.01 146.866 461.294 146.15 460.41 146.15Z",
    fill: "#F6F6F6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 165.91H388.85C387.464 165.91 386.34 167.034 386.34 168.42V178.44C386.34 179.826 387.464 180.95 388.85 180.95H398.87C400.256 180.95 401.38 179.826 401.38 178.44V168.42C401.38 167.034 400.256 165.91 398.87 165.91Z",
    fill: "#F6F6F6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 168.4H405.07C404.186 168.4 403.47 169.116 403.47 170V176.85C403.47 177.734 404.186 178.45 405.07 178.45H460.41C461.294 178.45 462.01 177.734 462.01 176.85V170C462.01 169.116 461.294 168.4 460.41 168.4Z",
    fill: "#F6F6F6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 188.16H388.85C387.464 188.16 386.34 189.284 386.34 190.67V200.69C386.34 202.076 387.464 203.2 388.85 203.2H398.87C400.256 203.2 401.38 202.076 401.38 200.69V190.67C401.38 189.284 400.256 188.16 398.87 188.16Z",
    fill: "#F6F6F6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 190.66H405.07C404.186 190.66 403.47 191.376 403.47 192.26V199.11C403.47 199.994 404.186 200.71 405.07 200.71H460.41C461.294 200.71 462.01 199.994 462.01 199.11V192.26C462.01 191.376 461.294 190.66 460.41 190.66Z",
    fill: "#F6F6F6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 210.42H388.85C387.464 210.42 386.34 211.544 386.34 212.93V222.95C386.34 224.336 387.464 225.46 388.85 225.46H398.87C400.256 225.46 401.38 224.336 401.38 222.95V212.93C401.38 211.544 400.256 210.42 398.87 210.42Z",
    fill: "#F6F6F6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 212.92H405.07C404.186 212.92 403.47 213.636 403.47 214.52V221.37C403.47 222.254 404.186 222.97 405.07 222.97H460.41C461.294 222.97 462.01 222.254 462.01 221.37V214.52C462.01 213.636 461.294 212.92 460.41 212.92Z",
    fill: "#F6F6F6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M398.87 232.68H388.85C387.464 232.68 386.34 233.804 386.34 235.19V245.21C386.34 246.596 387.464 247.72 388.85 247.72H398.87C400.256 247.72 401.38 246.596 401.38 245.21V235.19C401.38 233.804 400.256 232.68 398.87 232.68Z",
    fill: "#F6F6F6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M460.41 235.17H405.07C404.186 235.17 403.47 235.886 403.47 236.77V243.62C403.47 244.504 404.186 245.22 405.07 245.22H460.41C461.294 245.22 462.01 244.504 462.01 243.62V236.77C462.01 235.886 461.294 235.17 460.41 235.17Z",
    fill: "#F6F6F6"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.88 61.65C390.54 61.48 390.16 61.39 389.73 61.39H387.16V68.33H388.1V65.63H389.73C390.16 65.63 390.54 65.54 390.88 65.37C391.22 65.2 391.49 64.95 391.68 64.63C391.88 64.31 391.97 63.94 391.97 63.51C391.97 63.08 391.87 62.7 391.68 62.39C391.48 62.07 391.22 61.83 390.88 61.65ZM390.86 64.2C390.74 64.39 390.58 64.54 390.38 64.65C390.18 64.76 389.94 64.81 389.68 64.81H388.1V62.21H389.68C389.94 62.21 390.17 62.26 390.38 62.37C390.59 62.48 390.74 62.63 390.86 62.82C390.98 63.01 391.04 63.24 391.04 63.51C391.04 63.78 390.98 64.01 390.86 64.2Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.25 63.48C394.72 63.48 394.32 63.66 394.04 64.02C394 64.07 393.99 64.13 393.96 64.18V63.58H393.06V68.33H393.96V65.63C393.96 65.19 394.07 64.86 394.28 64.65C394.49 64.44 394.77 64.33 395.1 64.33C395.26 64.33 395.4 64.35 395.52 64.4C395.64 64.45 395.75 64.52 395.85 64.63L396.44 64.02C396.27 63.83 396.09 63.69 395.9 63.6C395.71 63.51 395.49 63.48 395.25 63.48Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35 63.81C399.97 63.59 399.55 63.48 399.09 63.48C398.63 63.48 398.21 63.59 397.84 63.81C397.47 64.03 397.17 64.32 396.95 64.69C396.73 65.06 396.62 65.48 396.62 65.94C396.62 66.4 396.73 66.83 396.95 67.2C397.17 67.58 397.47 67.87 397.84 68.1C398.21 68.32 398.63 68.43 399.09 68.43C399.55 68.43 399.98 68.32 400.35 68.1C400.73 67.88 401.02 67.58 401.25 67.2C401.47 66.82 401.58 66.4 401.58 65.94C401.58 65.48 401.47 65.06 401.25 64.69C401.03 64.32 400.73 64.02 400.35 63.81ZM400.44 66.78C400.31 67.02 400.12 67.21 399.89 67.36C399.66 67.5 399.39 67.57 399.08 67.57C398.77 67.57 398.52 67.5 398.29 67.36C398.06 67.22 397.87 67.03 397.74 66.78C397.61 66.54 397.54 66.26 397.54 65.95C397.54 65.64 397.61 65.37 397.74 65.13C397.87 64.89 398.06 64.7 398.29 64.57C398.52 64.44 398.79 64.36 399.08 64.36C399.37 64.36 399.65 64.43 399.88 64.57C400.11 64.71 400.29 64.89 400.43 65.13C400.57 65.37 400.64 65.64 400.64 65.95C400.64 66.26 400.57 66.54 400.44 66.78Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.25 63.81C405.9 63.59 405.51 63.48 405.08 63.48C404.73 63.48 404.41 63.56 404.12 63.7C403.86 63.83 403.65 64.02 403.48 64.25V63.58H402.58V70.32H403.48V67.66C403.64 67.88 403.85 68.07 404.1 68.2C404.39 68.35 404.72 68.43 405.08 68.43C405.51 68.43 405.91 68.32 406.25 68.1C406.59 67.88 406.87 67.59 407.08 67.22C407.28 66.85 407.38 66.43 407.38 65.96C407.38 65.49 407.28 65.07 407.08 64.7C406.88 64.33 406.6 64.03 406.25 63.81ZM406.25 66.8C406.12 67.04 405.94 67.24 405.71 67.38C405.48 67.52 405.22 67.59 404.92 67.59C404.62 67.59 404.37 67.52 404.13 67.38C403.9 67.24 403.72 67.05 403.6 66.8C403.48 66.56 403.41 66.28 403.41 65.97C403.41 65.66 403.47 65.37 403.6 65.13C403.73 64.89 403.9 64.7 404.13 64.55C404.36 64.41 404.62 64.34 404.91 64.34C405.2 64.34 405.47 64.41 405.7 64.55C405.93 64.69 406.11 64.88 406.24 65.13C406.37 65.38 406.44 65.65 406.44 65.96C406.44 66.27 406.37 66.56 406.24 66.8H406.25Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.69 63.78C411.35 63.58 410.96 63.48 410.53 63.48C410.07 63.48 409.65 63.59 409.28 63.81C408.91 64.03 408.62 64.32 408.4 64.69C408.18 65.06 408.07 65.48 408.07 65.95C408.07 66.42 408.18 66.85 408.4 67.22C408.62 67.59 408.92 67.89 409.3 68.1C409.68 68.32 410.1 68.43 410.59 68.43C410.96 68.43 411.31 68.36 411.64 68.22C411.97 68.08 412.25 67.88 412.48 67.61L411.9 67.02C411.74 67.21 411.55 67.35 411.32 67.44C411.09 67.53 410.85 67.58 410.59 67.58C410.27 67.58 409.99 67.51 409.74 67.37C409.49 67.23 409.3 67.04 409.17 66.79C409.09 66.64 409.04 66.47 409.01 66.29H412.72C412.74 66.2 412.75 66.11 412.76 66.04C412.76 65.96 412.76 65.89 412.76 65.83C412.76 65.38 412.67 64.97 412.47 64.62C412.28 64.27 412.01 63.99 411.68 63.79L411.69 63.78ZM409.7 64.51C409.93 64.38 410.2 64.31 410.51 64.31C410.82 64.31 411.05 64.37 411.26 64.49C411.47 64.61 411.63 64.79 411.74 65.01C411.82 65.16 411.86 65.34 411.88 65.53H409.01C409.04 65.36 409.09 65.2 409.16 65.06C409.29 64.82 409.47 64.63 409.7 64.5V64.51Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.94 63.48C415.41 63.48 415.01 63.66 414.73 64.02C414.69 64.07 414.68 64.13 414.65 64.18V63.58H413.75V68.33H414.65V65.63C414.65 65.19 414.76 64.86 414.97 64.65C415.18 64.44 415.46 64.33 415.79 64.33C415.95 64.33 416.09 64.35 416.21 64.4C416.33 64.45 416.44 64.52 416.54 64.63L417.13 64.02C416.96 63.83 416.78 63.69 416.59 63.6C416.4 63.51 416.18 63.48 415.94 63.48Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.38 61.59H418.48V63.58H417.31V64.4H418.48V68.33H419.38V64.4H420.55V63.58H419.38V61.59Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89 61.48C421.72 61.48 421.59 61.53 421.48 61.65C421.37 61.76 421.32 61.9 421.32 62.06C421.32 62.22 421.37 62.36 421.48 62.47C421.59 62.58 421.72 62.64 421.89 62.64C422.06 62.64 422.19 62.59 422.3 62.47C422.41 62.36 422.46 62.22 422.46 62.06C422.46 61.9 422.41 61.76 422.3 61.65C422.19 61.54 422.06 61.48 421.89 61.48Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.34 63.58H421.43V68.33H422.34V63.58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.97 63.78C426.63 63.58 426.24 63.48 425.81 63.48C425.35 63.48 424.93 63.59 424.56 63.81C424.19 64.03 423.9 64.32 423.68 64.69C423.46 65.06 423.35 65.48 423.35 65.95C423.35 66.42 423.46 66.85 423.68 67.22C423.9 67.59 424.2 67.89 424.58 68.1C424.96 68.32 425.38 68.43 425.87 68.43C426.24 68.43 426.59 68.36 426.92 68.22C427.25 68.08 427.53 67.88 427.76 67.61L427.18 67.02C427.02 67.21 426.83 67.35 426.6 67.44C426.37 67.53 426.13 67.58 425.87 67.58C425.55 67.58 425.27 67.51 425.02 67.37C424.77 67.23 424.58 67.04 424.45 66.79C424.37 66.64 424.32 66.47 424.29 66.29H428C428.02 66.2 428.03 66.11 428.04 66.04C428.04 65.96 428.04 65.89 428.04 65.83C428.04 65.38 427.95 64.97 427.75 64.62C427.56 64.27 427.29 63.99 426.96 63.79L426.97 63.78ZM424.98 64.51C425.21 64.38 425.48 64.31 425.79 64.31C426.1 64.31 426.33 64.37 426.54 64.49C426.75 64.61 426.91 64.79 427.02 65.01C427.1 65.16 427.14 65.34 427.16 65.53H424.29C424.32 65.36 424.37 65.2 424.44 65.06C424.57 64.82 424.75 64.63 424.98 64.5V64.51Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63 65.84C431.44 65.73 431.23 65.65 431.02 65.59C430.81 65.53 430.6 65.47 430.4 65.41C430.2 65.35 430.04 65.28 429.92 65.19C429.8 65.1 429.74 64.98 429.74 64.82C429.74 64.66 429.81 64.54 429.95 64.45C430.09 64.36 430.28 64.31 430.54 64.31C430.8 64.31 431.01 64.36 431.2 64.45C431.39 64.54 431.56 64.68 431.7 64.85L432.28 64.27C432.09 64.01 431.86 63.81 431.57 63.69C431.28 63.56 430.95 63.49 430.57 63.49C430.22 63.49 429.91 63.55 429.66 63.66C429.41 63.77 429.21 63.94 429.08 64.15C428.95 64.36 428.87 64.61 428.87 64.89C428.87 65.17 428.93 65.41 429.06 65.59C429.18 65.77 429.34 65.91 429.53 66.01C429.72 66.11 429.93 66.19 430.15 66.25C430.37 66.31 430.57 66.37 430.77 66.43C430.97 66.49 431.12 66.57 431.24 66.67C431.36 66.77 431.42 66.9 431.42 67.08C431.42 67.26 431.34 67.39 431.19 67.48C431.04 67.58 430.82 67.63 430.54 67.63C430.26 67.63 430.01 67.58 429.78 67.47C429.55 67.36 429.35 67.21 429.18 67L428.6 67.58C428.75 67.76 428.92 67.91 429.11 68.04C429.3 68.17 429.53 68.27 429.77 68.34C430.01 68.41 430.26 68.45 430.53 68.45C431.06 68.45 431.49 68.32 431.81 68.06C432.13 67.8 432.28 67.45 432.28 67C432.28 66.71 432.22 66.47 432.1 66.29C431.98 66.11 431.82 65.97 431.62 65.86L431.63 65.84Z",
    fill: "#F6F6F6"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.15 45.48H357.16C361.58 45.48 365.16 49.06 365.16 53.48V250C365.16 254.42 361.58 258 357.16 258H72.15C67.73 258 64.15 254.42 64.15 250V53.48C64.15 49.06 67.73 45.48 72.15 45.48Z",
    fill: "url(#paint4_linear_346_1217)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M201.23 124.94C204.41 124.94 206.97 127.51 206.97 130.68C206.97 133.85 204.4 136.42 201.23 136.42C198.06 136.42 195.49 133.85 195.49 130.68C195.49 127.51 198.06 124.94 201.23 124.94ZM229.26 137.11L227.92 131.67C227.5 129.99 225.97 128.76 224.21 128.76C222.45 128.76 220.92 129.95 220.5 131.67L219.16 137.07L213.8 138.3C212.08 138.68 210.85 140.21 210.85 141.98C210.85 143.75 212 145.27 213.68 145.73L219.16 147.22L220.54 152.7C220.96 154.38 222.49 155.61 224.25 155.61C226.01 155.61 227.54 154.42 227.96 152.7L229.3 147.26L234.74 145.92C236.42 145.5 237.65 143.97 237.65 142.21C237.65 140.45 236.46 138.92 234.74 138.5L229.3 137.16L229.26 137.12V137.11ZM232.28 124.48L239.02 127.31L241.7 134.01C242.27 135.46 243.69 136.42 245.26 136.42C246.83 136.42 248.25 135.46 248.82 134.01L251.5 127.35L258.16 124.67C259.61 124.1 260.57 122.68 260.57 121.11C260.57 119.54 259.61 118.12 258.16 117.55L251.5 114.87L248.82 108.21C248.25 106.76 246.83 105.8 245.26 105.8C243.69 105.8 242.27 106.76 241.7 108.21L239.06 114.83L232.44 117.36C230.99 117.9 229.99 119.31 229.95 120.88C229.95 122.45 230.83 123.87 232.29 124.48H232.28ZM260.58 140.25V178.54C260.58 189.11 252 197.68 241.44 197.68H187.84C177.27 197.68 168.7 189.1 168.7 178.54V124.94C168.7 114.37 177.28 105.8 187.84 105.8H226.13C228.24 105.8 229.96 107.52 229.96 109.63C229.96 111.74 228.24 113.46 226.13 113.46H187.84C181.52 113.46 176.35 118.63 176.35 124.95V150.18L178.49 148.04C183.62 142.91 192.01 142.91 197.17 148.04L218.54 169.41C220.61 171.48 224.02 171.48 226.08 169.41L228.3 167.19C233.43 162.06 241.82 162.06 246.98 167.19L252.95 173.16V140.27C252.95 138.16 254.67 136.44 256.78 136.44C258.89 136.44 260.61 138.16 260.61 140.27H260.57L260.58 140.25ZM252 183.02L241.51 172.53C239.37 170.39 235.84 170.39 233.66 172.53L231.44 174.75C226.39 179.8 218.12 179.8 213.06 174.75L191.69 153.38C189.55 151.24 186.02 151.24 183.84 153.38L176.26 160.96V178.53C176.26 184.85 181.43 190.02 187.75 190.02H241.35C246.1 190.02 250.16 187.15 251.92 183.01H252V183.02Z",
    fill: "#F6F6F6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M84.15 55.48H76.15C75.0455 55.48 74.15 56.3754 74.15 57.48V65.48C74.15 66.5846 75.0455 67.48 76.15 67.48H84.15C85.2546 67.48 86.15 66.5846 86.15 65.48V57.48C86.15 56.3754 85.2546 55.48 84.15 55.48Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_346_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 58,
    width: 8,
    height: 7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M83.31 58.32H76.98V64.65H83.31V58.32Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_346_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.31 59.63V59.1H82.52V58.31H81.99V59.1H78.3V58.31H77.77V59.1H76.98V59.63H77.77V63.32H76.98V63.85H77.77V64.64H78.3V63.85H81.99V64.64H82.52V63.85H83.31V63.32H82.52V59.63H83.31ZM81.99 63.33H78.3V59.64H81.99V63.33Z",
    fill: "#F6F6F6"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.64 58.47L88.13 64.58H89.19L89.66 63.4H92.29L92.76 64.58H93.84L91.34 58.47H90.64ZM90.01 62.53L90.98 60.09L91.94 62.53H90.01Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63 60.3C96.15 60.3 95.8 60.46 95.56 60.79C95.56 60.8 95.55 60.82 95.54 60.84V60.39H94.58V64.58H95.54V62.25C95.54 61.89 95.63 61.62 95.8 61.46C95.97 61.3 96.2 61.21 96.46 61.21C96.58 61.21 96.69 61.23 96.78 61.26C96.87 61.29 96.96 61.35 97.03 61.43L97.66 60.78C97.51 60.61 97.36 60.49 97.19 60.41C97.02 60.33 96.83 60.3 96.62 60.3H96.63Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.74 58.65H98.78V60.39H97.78V61.26H98.78V64.58H99.74V61.26H100.75V60.39H99.74V58.65Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71 60.6C104.4 60.41 104.06 60.31 103.68 60.31C103.37 60.31 103.08 60.38 102.83 60.52C102.66 60.61 102.52 60.74 102.39 60.89V58.31H101.43V64.59H102.39V64.11C102.51 64.25 102.65 64.38 102.82 64.47C103.07 64.61 103.36 64.68 103.68 64.68C104.06 64.68 104.4 64.58 104.71 64.39C105.02 64.2 105.26 63.94 105.43 63.61C105.61 63.28 105.7 62.91 105.7 62.51C105.7 62.11 105.61 61.73 105.43 61.4C105.25 61.07 105.01 60.81 104.71 60.61V60.6ZM104.56 63.15C104.46 63.34 104.32 63.49 104.14 63.6C103.96 63.71 103.76 63.76 103.52 63.76C103.28 63.76 103.08 63.71 102.9 63.6C102.72 63.49 102.58 63.34 102.48 63.15C102.38 62.96 102.33 62.74 102.33 62.49C102.33 62.24 102.38 62.02 102.48 61.83C102.58 61.64 102.72 61.49 102.9 61.38C103.08 61.27 103.29 61.22 103.52 61.22C103.75 61.22 103.96 61.27 104.14 61.38C104.32 61.49 104.46 61.64 104.56 61.83C104.66 62.02 104.71 62.24 104.71 62.49C104.71 62.74 104.66 62.96 104.56 63.15Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.54 60.59C109.21 60.4 108.84 60.3 108.42 60.3C108 60.3 107.64 60.4 107.31 60.59C106.98 60.79 106.72 61.05 106.52 61.37C106.32 61.7 106.23 62.06 106.23 62.47C106.23 62.88 106.33 63.25 106.52 63.58C106.72 63.91 106.98 64.17 107.31 64.37C107.64 64.57 108.01 64.66 108.42 64.66C108.83 64.66 109.21 64.56 109.54 64.37C109.87 64.17 110.14 63.91 110.33 63.58C110.53 63.25 110.62 62.88 110.62 62.47C110.62 62.06 110.52 61.69 110.33 61.37C110.14 61.04 109.87 60.78 109.54 60.59ZM109.49 63.13C109.39 63.32 109.25 63.47 109.06 63.58C108.88 63.69 108.67 63.74 108.43 63.74C108.19 63.74 107.99 63.69 107.81 63.58C107.63 63.47 107.48 63.32 107.38 63.13C107.28 62.94 107.23 62.72 107.23 62.48C107.23 62.24 107.28 62.02 107.38 61.83C107.48 61.64 107.62 61.5 107.81 61.39C107.99 61.28 108.2 61.23 108.43 61.23C108.66 61.23 108.88 61.28 109.06 61.39C109.24 61.5 109.38 61.64 109.49 61.83C109.59 62.02 109.65 62.23 109.65 62.48C109.65 62.73 109.6 62.94 109.5 63.13H109.49Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 60.88C114.34 60.74 114.2 60.61 114.03 60.51C113.78 60.37 113.5 60.3 113.18 60.3C112.8 60.3 112.46 60.4 112.15 60.59C111.84 60.79 111.6 61.05 111.43 61.38C111.25 61.71 111.16 62.08 111.16 62.49C111.16 62.9 111.25 63.27 111.43 63.59C111.61 63.92 111.85 64.18 112.15 64.37C112.46 64.56 112.8 64.66 113.18 64.66C113.5 64.66 113.79 64.59 114.04 64.45C114.21 64.36 114.35 64.23 114.47 64.09V64.57H115.43V60.38H114.47V60.86L114.46 60.88ZM114.19 63.4C113.97 63.64 113.69 63.76 113.33 63.76C113.1 63.76 112.89 63.71 112.71 63.6C112.53 63.49 112.39 63.34 112.29 63.15C112.19 62.96 112.14 62.74 112.14 62.49C112.14 62.24 112.19 62.02 112.29 61.83C112.39 61.64 112.53 61.49 112.71 61.38C112.89 61.27 113.09 61.22 113.33 61.22C113.57 61.22 113.78 61.27 113.95 61.38C114.13 61.49 114.27 61.64 114.36 61.83C114.46 62.02 114.51 62.24 114.51 62.49C114.51 62.86 114.4 63.17 114.18 63.41L114.19 63.4Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53 60.3C118.05 60.3 117.7 60.46 117.46 60.79C117.46 60.8 117.45 60.82 117.44 60.84V60.39H116.48V64.58H117.44V62.25C117.44 61.89 117.53 61.62 117.7 61.46C117.87 61.3 118.1 61.21 118.36 61.21C118.48 61.21 118.59 61.23 118.68 61.26C118.77 61.29 118.86 61.35 118.93 61.43L119.56 60.78C119.41 60.61 119.26 60.49 119.09 60.41C118.92 60.33 118.73 60.3 118.52 60.3H118.53Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.95 58.3V60.88C122.83 60.74 122.69 60.61 122.52 60.51C122.27 60.37 121.99 60.3 121.67 60.3C121.29 60.3 120.95 60.4 120.64 60.59C120.33 60.79 120.09 61.05 119.92 61.38C119.74 61.71 119.65 62.08 119.65 62.49C119.65 62.9 119.74 63.27 119.92 63.59C120.1 63.92 120.34 64.18 120.64 64.37C120.95 64.56 121.29 64.66 121.67 64.66C121.99 64.66 122.28 64.59 122.53 64.45C122.7 64.36 122.84 64.23 122.96 64.09V64.57H123.92V58.29H122.96L122.95 58.3ZM122.45 63.6C122.27 63.71 122.06 63.76 121.83 63.76C121.6 63.76 121.39 63.71 121.21 63.6C121.03 63.49 120.89 63.34 120.79 63.15C120.69 62.96 120.64 62.74 120.64 62.49C120.64 62.24 120.69 62.02 120.79 61.83C120.89 61.64 121.03 61.49 121.21 61.38C121.39 61.27 121.59 61.22 121.83 61.22C122.07 61.22 122.28 61.27 122.45 61.38C122.63 61.49 122.77 61.64 122.86 61.83C122.96 62.02 123.01 62.24 123.01 62.49C123.01 62.74 122.96 62.96 122.86 63.15C122.76 63.34 122.62 63.49 122.45 63.6Z",
    fill: "#F6F6F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_346_1217",
    x1: 243,
    y1: 268,
    x2: 243,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1F0825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_346_1217",
    x1: 5,
    y1: 20.02,
    x2: 481,
    y2: 20.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09090E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12121B",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_346_1217",
    x1: 34.44,
    y1: 45.48,
    x2: 34.44,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09090E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12121B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_346_1217",
    x1: 424.17,
    y1: 45.48,
    x2: 424.17,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09090E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12121B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_346_1217",
    x1: 64.15,
    y1: 151.74,
    x2: 365.16,
    y2: 151.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09090E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12121B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_346_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 273,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding1);
export default __webpack_public_path__ + "static/media/onboarding_1.c5b71958e7f60303be4478ec48103145.svg";
export { ForwardRef as ReactComponent };